import dayjs from 'dayjs'
import _ from 'lodash'
import CryptoJS from 'crypto-js'
import { loadTossPayments } from '@tosspayments/payment-sdk'
import { numberComma } from '~/utils'
import { cartTag } from '~/utils/criteo'

const orMixin = {
  methods: {
    async isInicisPayTarget (pymtCd) {
      const pgCdMap = await this.selCdMap(['CD_00631', 'CD_00639', 'CD_00655'])
      const tossDefaultUseYn = (pgCdMap?.CD_00631 || [])[0]?.cmmnCd?.toUpperCase() || 'Y'
      if (tossDefaultUseYn === 'N') {
        return true
      }

      const inicisIdList = (pgCdMap?.CD_00639 || []).map(item => item.cmmnCd?.toUpperCase())
      const currentMbEid = this.$store.getters['session/getMbEid']
      if (inicisIdList.includes(currentMbEid?.toUpperCase())) {
        return true
      }

      const targetPymtCd = String(pymtCd || '').trim()
      const pgByPymtCd = (pgCdMap?.CD_00655 || []).find(item => String(item.cmmnCd || '').trim() === targetPymtCd)
      return String(pgByPymtCd?.fstUserFd || '').trim() === '04'
    },
    setPageName (name, params) {
      console.log('==================== ' + name + (params ? '::params' : ''), params)
      this.$store.commit('page/setName', name)
    },
    getHomeUrl (spbkSeCd) { // 홈 URL
      console.log('spbkSeCd ==={}', spbkSeCd)
      if (spbkSeCd) {
        if (spbkSeCd === '02') {
          return '/ds/pickupOrder/C119'
        } else if (spbkSeCd === '03') {
          return ''
        } else if (spbkSeCd === '04') {
          return '/ds/bulkOrder/C116'
        } else if (spbkSeCd === '05') {
          return '/ds/quickOrder/C118'
        } else {
          return '/ds'
        }
      } else {
        return '/ds'
      }
    },
    closePpup (popupType) {
      this.popupType = popupType ?? 'none'
    },
    // 주문 배송지 변경 가능여부 확인 (배송지변경 팝업 띄우기 전 호출)
    // 반환: { success: 30미만이면 true, data: 주문상태코드 }
    async chkOrDvyaChgAble (orNo) {
      return await this.$AxiosBuilder
        .data({ orNo })
        .build()
        .post('/or/orb/chkOrDvyaChgAble')
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          console.log('chkOrDvyaChgAble error', err)
        })
    },
    // 주문 배송지 변경 API 호출 (주문완료/주문목록/주문상세의 배송지변경 팝업에서 배송지 [선택] 시)
    async chgOrDvya (orNo, dvya) {
      const params = {
        orNo, // 주문번호
        dvyaSeq: dvya.dvyaSeq, // 선택한 배송지순번
        addrNknm: dvya.dvyaNm, // 배송지명(주소별칭)
        adrerEfnm: dvya.rcpmEfnm, // 받는분 이름
        adrerEmpno: dvya.rcpmCntp1Etno, // 받는분 전화번호1
        adrerEtno: dvya.rcpmCntp2Etno, // 받는분 전화번호2
        zip: dvya.addrZip, // 우편번호
        rnBassEaddr: dvya.addrBassEaddr, // 도로명기본주소
        rnDtlEaddr: dvya.dtlEaddr, // 도로명상세주소
        dlvRqstCd: dvya.rqstTy, // 배송요청코드
        dlvRqstCn: dvya.rqstMtr // 배송요청내용
      }
      return await this.$AxiosBuilder
        .data(params)
        .build()
        .post('/or/orb/chgOrDvya')
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          console.log('chgOrDvya error', err)
        })
    },
    manWon (won) {
      return won / 10000
    },
    formatTime (timeStr) {
      const str = this.defaultString(timeStr)
      return str.length === 4 ? str.substring(0, 2) + ':' + str.substring(2) : str
    },
    getUserTy () { // 사용자유형(CD_00166) 조회 [10:개인-일반, 21:개인-미성년(14세미만), 22:개인-미성년(19세미만), 30:개인-외국인, 40:기업, 50:비회원]
      return this.$store.getters['session/getUserTy']
    },
    getChnlCd () { // 회원정보에서 채널코드 추출
      // 기업회원(40)인 경우 채널코드 B2B(02)
      return (this.getUserTy() === '40') ? '02' : '01'
    },
    getMbYn () { // 회원정보에서 회원여부 추출
      return (['10', '21', '22', '30', '40'].includes(this.getUserTy())) ? 'Y' : 'N'
    },
    getCdNm (cdList, cmmnCd) { // 코드명 조회
      const cdObj = this.find(cdList, { cmmnCd })
      return cdObj ? cdObj?.cmmnCdNm : ''
    },
    toOrTyCd (spbkSeCd) { // 장바구니구분코드에서 주문유형 추출
      switch (spbkSeCd) {
        case '01': // 택배배송
        case '02': // 매장픽업
          return '01' // 일반주문

        case '03': // 정기배송
          return '02' // 정기주문

        case '04': // 대량주문
          return '03' // 대량주문

        case '05': // 오늘배송
          return '04' // 오늘배송주문
      }

      return null
    },
    toDefaultDlvFomCd (spbkSeCd) { // 장바구니구분코드에서 기본 배송형태코드 추출
      switch (spbkSeCd) {
        case '01': // 택배배송
        case '03': // 정기배송
          return '01' // 택배

        case '02': // 매장픽업
          return '02' // 픽업

        case '04': // 대량주문 (용차/픽업 중에서 기본값 용차로 반환)
        case '05': // 오늘배송
          return '03' // 용차
      }

      return null
    },
    async post (url, param, title, fnNm, useErrInfo) { // Axios POST 요청
      console.log(title + '::' + fnNm + '(' + url + ')::req', param)
      return await this.$AxiosBuilder
        .data(param)
        .build()
        .post(url)
        .then((response) => {
          const res = response.data
          if (res?.success) {
            if (res?.message || !this.isEmpty(res?.extraData)) {
              console.log('◀■■ ' + title, res)
            } else {
              console.log('◀■■ ' + title, res?.data)
            }
            return res?.data
          } else {
            console.log('◀■■ [ERR] ' + title, res?.message, res)
            if (res?.returnCode === 'NO_LOGIN') {
              if (this?.popupType) {
                this.popupType = 'none'
              }
              this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
            } else if (useErrInfo) {
              return {
                errInfo: {
                  returnCode: res.returnCode,
                  message: res.message,
                  extraString: res.extraString,
                  extraData: res.extraData
                }
              }
            }
          }
        })
        .catch((err) => {
          console.log('◀■■ [I/O ERR] ' + title, err)
        })
    },
    async get (url, param, title, fnNm, useErrInfo) { // Axios GET 요청
      console.log(title + '::' + fnNm + '(' + url + ')::req', param)
      return await this.$AxiosBuilder
        .params(param)
        .build()
        .get(url)
        .then((response) => {
          const res = response.data
          if (res?.success) {
            if (res?.message || !this.isEmpty(res?.extraData)) {
              console.log('◀■■ ' + title, res)
            } else {
              console.log('◀■■ ' + title, res?.data)
            }
            return res?.data
          } else {
            console.log('◀■■ [ERR] ' + title, res?.message, res)
            if (res?.returnCode === 'NO_LOGIN') {
              if (this?.popupType) {
                this.popupType = 'none'
              }
              this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
            } else if (useErrInfo) {
              return {
                errInfo: {
                  returnCode: res.returnCode,
                  message: res.message,
                  extraString: res.extraString,
                  extraData: res.extraData
                }
              }
            }
          }
        })
        .catch((err) => {
          console.log('◀■■ [I/O ERR] ' + title, err)
        })
    },
    goBack () { // 주문서 뒤로가기 이벤트 처리
      if (this.popupType) {
        this.popupType = 'none' // 팝업창 닫기
      }
    },

    // //////////////////////////////////////////////////////////////
    // 장바구니 공통
    async selSpbk (spbkSeCd, existStrCd = false) { // 장바구니 조회
      // existStrCd 장바구니에서 매장 정보가 존재할 시에는 매장픽업 장바구니 관련 정보를 업데이트 하지 않도록 한다
      this.$EventBus.$emit('eb-able-dlv', true) // 배송가능여부 이벤트 발생 (배송가능으로 초기화)

      const mbMngNo = this.getMbMngNo()

      if (!mbMngNo) {
        return
      }

      const spbk = await this.post('/or/orc/selSpbk', { spbkSeCd, mbMngNo }, '장바구니 조회', 'selSpbk')

      if (!spbk) {
        return
      }

      // 장바구니 목록 갱신
      this.removeAll(this.spbkList)
      spbk.spbkList.forEach((row) => {
        // process.env.WEB_BASE_URL
        // /images/content/noimage.png
        // if (row.pdImgUrl) {
        //   row.pdImgUrl = process.env.CDN_BASE_URL + row.pdImgUrl + '/dims/optimize/dims/resize/300x400'
        // } else {
        //   row.pdImgUrl = process.env.WEB_BASE_URL + '/images/content/noimage.png'
        // }

        // 택배배송, 매장픽업 정기배송 대량배송 가능 여부가 N 일 시 각 항목에서 판매종료로 보이도록 처리
        if (row.sleStsCd === '05') { // 판매종료 상태일 경우
          row.prdType = 'PRD_SELEND'
        } else if (row.sleStsCd === '04') { // 판매중지 상태일 경우
          row.prdType = 'PRD_SELSTOP'
        } else if (spbkSeCd === '01' && row.pdsOrPsblYn !== 'Y') {
          row.prdType = 'PRD_SOLDOUT'
        } else if (spbkSeCd === '02' && row.pkupOrPsblYn !== 'Y') {
          row.prdType = 'PRD_SOLDOUT'
        } else if (spbkSeCd === '03' && row.fdrmOrPsblYn !== 'Y') {
          row.prdType = 'PRD_SOLDOUT'
        } else if (spbkSeCd === '04' && row.massOrPsblYn !== 'Y') {
          row.prdType = 'PRD_SOLDOUT'
        } else if (spbkSeCd === '05' && row.quickOrPsblYn !== 'Y') {
          row.prdType = 'PRD_SOLDOUT'
        } else if ((spbkSeCd === '01' || spbkSeCd === '03') && row.sleStsCd === '03' && row.prdType === 'PRD_STRGY') {
          row.prdType = 'PRD_STRGY'
        }
        this.spbkList.push(row)
      })

      if (spbkSeCd === '01' || spbkSeCd === '05') { // 택배배송 오늘배송 장바구니
        this.copyTo(spbk.dlvDtInfo, this.dlvDtInfo) // 배송일 정보 설정
      } else if (spbkSeCd === '02' && !existStrCd) { // 매장픽업 장바구니
        try { // [FO] 기본픽업매장를 장바구니 사이드바로 전송
          // 이번만 배송지 정보를 localStorage에서 조회 후
          // storagePkupStr 가 존재할 시 spbk.bassPkupStr 를 덮어 씌운다
          // const storagePkupStr = JSON.parse(localStorage.getItem('pkupStr'))

          // if (storagePkupStr?.strCd) {
          //   // 로컬스토리지에 있는 매장코드로 재조회
          //   const newStoragePkupStr = await this.post('/ms/msg/selStr', { inclusiveStrCd: storagePkupStr.strCd })
          //   spbk.bassPkupStr = newStoragePkupStr[0]
          // }
          this.dlvcPlcy.zip = spbk.bassPkupStr?.strZip
          this.$EventBus.$emit('eb-change-pkup-str', spbk.bassPkupStr)
        } catch (e) {
        }
      } else if (spbkSeCd === '04') { // 대량주문 장바구니
        this.selSkipCntrStckList()
      }

      if (spbk.bassDvya) { // 기본배송지
        try { // 기본배송지를 [FO] 장바구니 사이드바로([MO] 장바구니 탭으로) 전송
          this.dlvcPlcy.zip = spbk.bassDvya.addrZip

          this.$EventBus.$emit('eb-change-dvya', {
            dvyaSeq: spbk.bassDvya.dvyaSeq, // 배송지순번
            bassDvyaYn: spbk.bassDvya.bassDvyaYn, //  기본배송지여부
            dvyaNm: this.unescape(spbk.bassDvya.dvyaNm), //  배송지명
            addrZip: spbk.bassDvya.addrZip, //  우편번호
            addrBassEaddr: this.unescape(spbk.bassDvya.addrBassEaddr), //  기본주소
            dtlEaddr: this.unescape(spbk.bassDvya.dtlEaddr), //  상세주소
            rcpmEfnm: this.unescape(spbk.bassDvya.rcpmEfnm), //  수령인명
            rcpmCntp1Etno: spbk.bassDvya.rcpmCntp1Etno, //  수령인연락처1
            rqstTy: spbk.bassDvya.rqstTy, // 요청유형
            rqstMtr: this.unescape(spbk.bassDvya.rqstMtr) // 요청사항
          }, spbkSeCd)
        } catch (e) {
        }
      } else if (spbkSeCd === '01') { // 택배배송은 기본배송지 없어도 기본배송비 가져오기 위해 eb-change-dvya 이벤트 발생
        this.$EventBus.$emit('eb-change-dvya', null, spbkSeCd)
      }

      const spbkContList = [ // 장바구니별 건수 목록
        { spbkSeCd: '01', spbkCont: spbk.spbkCont.spbk01Cont },
        { spbkSeCd: '02', spbkCont: spbk.spbkCont.spbk02Cont },
        { spbkSeCd: '03', spbkCont: spbk.spbkCont.spbk03Cont },
        { spbkSeCd: '04', spbkCont: spbk.spbkCont.spbk04Cont },
        { spbkSeCd: '05', spbkCont: spbk.spbkCont.spbk05Cont }
      ]

      this.pushCriteo(spbk)

      this.$emit('change-cont', spbkContList)
      return spbk
    },
    async selBassDlvcPlcy (spbkSeCd, zip, dlvFomCd, dlvcPlcyCd) { // 기본배송비정책 조회
      const dlvcPlcyRqstList = [{
        dlvFomCd: dlvFomCd || this.toDefaultDlvFomCd(spbkSeCd), // 배송형태코드(CD_00049) [01:택배, 02:픽업, 03:용차, 04:상품권]
        orTyCd: this.toOrTyCd(spbkSeCd), // 주문유형(CD_00048) [01:일반주문, 02:정기주문, 03:대량주문, 04:오늘배송]
        zip, // 우편번호
        dlvcPlcyCd: spbkSeCd === '04' || spbkSeCd === '05' ? dlvcPlcyCd : ''
      }]

      const result = await this.post('/dl/dlp-api/selDlvcPlcyInfo', { dlvcPlcyRqstList }, '기본배송비정책 조회', 'selBassDlvcPlcy')

      if (result?.dlvcPlcyList?.length > 0) {
        return {
          bassDlvcAm: this.toNumber(result?.dlvcPlcyList[0].bassDlvAm), // 기본배송비
          ismtDlvcAm: this.toNumber(result?.dlvcPlcyList[0].ismtDlvAm) + this.toNumber(result?.dlvcPlcyList[0].jejuAditDlvAm), // 도서산간배송비
          stdrAm: this.toNumber(result?.dlvcPlcyList[0].stdrAm), // 무료배송 주문상품금액
          dlvcPlcyCd: result?.dlvcPlcyList[0].dlvcPlcyCd,
          freeDlvAm: this.toNumber(result?.dlvcPlcyList[0].freeDlvAm) // 오늘배송 무료배송 주문상품금액
        }
      }
    },
    async setBassDlvc (reqOpt, dlvcList, dlvcPlcy, isOrPdAm, dlvcPlcyCd) { // 기본배송비 설정
      if (reqOpt.spbkSeCd === '01') {
        const bassDlvcPlcy = await this.selBassDlvcPlcy(reqOpt.spbkSeCd, reqOpt.zip)
        if (bassDlvcPlcy) {
          if (dlvcPlcy) {
            this.$set(dlvcPlcy, 'bassDlvcAm', bassDlvcPlcy.bassDlvcAm) // 기본배송비
            this.$set(dlvcPlcy, 'ismtDlvcAm', bassDlvcPlcy.ismtDlvcAm) // 도서산간배송비
            this.$set(dlvcPlcy, 'stdrAm', bassDlvcPlcy.stdrAm) // 무료배송 주문상품금액
          }

          // 기본배송비 설정
          this.$set(dlvcList[0], 'dlvcPlcyCd', bassDlvcPlcy.dlvcPlcyCd) // 배송비정책코드
          if (isOrPdAm) {
            this.$set(dlvcList[0], 'dlvcAm', reqOpt.orPdAm === 0 || reqOpt.orPdAm >= bassDlvcPlcy.stdrAm ? 0 : bassDlvcPlcy.bassDlvcAm) // 기본배송비결제액 = 기본배송비
          } else {
            this.$set(dlvcList[0], 'dlvcAm', bassDlvcPlcy.bassDlvcAm) // 배송비금액
          }

          // 도서산간배송비 설정
          this.$set(dlvcList[1], 'dlvcPlcyCd', bassDlvcPlcy.dlvcPlcyCd) // 배송비정책코드
          this.$set(dlvcList[1], 'dlvcAm', bassDlvcPlcy.ismtDlvcAm) // 배송비금액
        }
      } else if (reqOpt.spbkSeCd === '02') {
        this.$set(dlvcPlcy, 'pkupFee', reqOpt.pkupFee) // 픽업수수료
        this.$set(dlvcList[0], 'dlvcAm', reqOpt.pkupFee) // 배송비금액
      } else if (reqOpt.spbkSeCd === '03') {
        const bassDlvcPlcy = await this.selBassDlvcPlcy(reqOpt.spbkSeCd, reqOpt.zip)
        if (bassDlvcPlcy) {
          this.$set(dlvcPlcy, 'bassDlvcAm', bassDlvcPlcy.bassDlvcAm) // 기본배송비
          this.$set(dlvcPlcy, 'stdrAm', bassDlvcPlcy.stdrAm) // 기준금액 (주문가능금액)

          // 기본배송비
          this.$set(dlvcList[0], 'dlvcPlcyCd', bassDlvcPlcy.dlvcPlcyCd) // 배송비정책코드
          this.$set(dlvcList[0], 'dlvcAm', bassDlvcPlcy.bassDlvcAm) // 배송비금액
        }
      } else if (reqOpt.spbkSeCd === '04') {
        // this.$set(dlvcPlcy, 'htrkDlvcAm', 38000) // 용차배송비
        // this.$set(dlvcList[0], 'dlvcAm', 38000) // 배송비금액

        const bassDlvcPlcy = await this.selBassDlvcPlcy(reqOpt.spbkSeCd, reqOpt?.zip, '', dlvcPlcyCd)
        if (bassDlvcPlcy) {
          this.$set(dlvcPlcy, 'htrkDlvcAm', bassDlvcPlcy.bassDlvcAm) // 용차배송비
          this.$set(dlvcList[0], 'dlvcAm', bassDlvcPlcy.bassDlvcAm) // 배송비금액
          this.$set(dlvcList[0], 'dlvcPlcyCd', dlvcPlcyCd) // 배송비정책코드
          this.$set(dlvcPlcy, 'stdrAm', bassDlvcPlcy.stdrAm) // 무료배송 주문상품금액
          this.$set(dlvcPlcy, 'dlvcPlcyCd', dlvcPlcyCd) // 무료배송 주문상품금액
        }
      } else if (reqOpt.spbkSeCd === '05') {
        const bassDlvcPlcy = await this.selBassDlvcPlcy('05', '', '03', 'DLVC000005')
        if (bassDlvcPlcy) {
          this.$set(dlvcPlcy, 'bassDlvcAm', bassDlvcPlcy.bassDlvcAm) // 기본배송비
          this.$set(dlvcList[0], 'dlvcAm', bassDlvcPlcy.bassDlvcAm) // 배송비금액
          this.$set(dlvcList[0], 'dlvcPlcyCd', bassDlvcPlcy.dlvcPlcyCd) // 배송비정책코드
          this.$set(dlvcPlcy, 'stdrAm', bassDlvcPlcy.stdrAm) // 최소주문 상품금액
          this.$set(dlvcPlcy, 'dlvcPlcyCd', bassDlvcPlcy.dlvcPlcyCd) // 배송비정책코드
          this.$set(dlvcPlcy, 'freeDlvAm', bassDlvcPlcy.freeDlvAm) // 무료배송 주문상품금액
        }

        if (isOrPdAm) {
          this.$set(dlvcList[0], 'dlvcAm', reqOpt.orPdAm === 0 || (bassDlvcPlcy.freeDlvAm > 0 && reqOpt.orPdAm >= bassDlvcPlcy.freeDlvAm) ? 0 : bassDlvcPlcy.bassDlvcAm) // 기본배송비결제액 = 기본배송비
        } else {
          this.$set(dlvcList[0], 'dlvcAm', bassDlvcPlcy.bassDlvcAm) // 배송비금액
        }
      }
    },
    async selAditDlvcPlcyList (spbkSeCd, zip, aditPdList, dlvFomCd) { // 상품추가배송비 조회 - 상품번호(모품번) 기준
      const dlvcPlcyRqstList = []

      aditPdList?.forEach((row) => {
        dlvcPlcyRqstList.push({
          pdNo: row.pdNo, // 상품번호
          dlvcPlcyCd: row.dlvcPlcyCd, // 배송비정책코드
          orQy: row.spbkQy, // 주문수량
          orAm: this.toNumber(row.spbkQy) * this.toNumber(row.sleUtpc), // 주문금액
          dlvFomCd: dlvFomCd || this.toDefaultDlvFomCd(spbkSeCd), // 배송형태코드(CD_00049) [01:택배, 02:픽업, 03:용차, 04:상품권]
          orTyCd: this.toOrTyCd(spbkSeCd), // 주문유형(CD_00048) [01:일반주문, 02:정기주문, 03:대량주문]
          zip // 우편번호
        })
      })

      if (dlvcPlcyRqstList.length > 0) {
        const result = await this.post('/dl/dlp-api/selDlvcPlcyInfo', { dlvcPlcyRqstList }, '상품추가배송비 조회', 'selAditDlvcPlcy')
        return result?.dlvcPlcyList.filter((row) => { return row.aditDlvcTgtYn === 'Y' && row.aditDlvcAm && row.aditDlvcStdrQy }) // 추가배송비정책 목록 추출
      }
    },
    toPdListByPdNo (onldPdList) { // 자품번 주문상품목록을 모품번 주문상품목록으로 변환 (주문수량 통합)
      const pnoPdList = []
      const cnoPdList = this.cloneDeep(onldPdList) // 자품번 주문상품목록 원본 수정을 피하기위해 clone 생성
      cnoPdList.forEach((row) => {
        const orPd = this.find(pnoPdList, { pdNo: row.pdNo, exhPdNm: row.exhPdNm })
        if (orPd) { // 상품번호가 동일하면 주문수량 sum
          orPd.spbkQy += row.spbkQy // 주문수량
        } else {
          pnoPdList.push(row)
        }
      })
      return pnoPdList
    },
    async setAllAditDlvc (spbkSeCd, zip, spbkList, dlvcList) { // 모든 추가배송비 설정
      const selSpbkList = spbkList?.filter((row) => { return row.prdType === 'PRD_NORMAL' }) // 주문가능 장바구니 추출 - 온라인상품번호(자품번) 기준
      if (this.size(selSpbkList) === 0) {
        return
      }

      const aditPdList = this.toPdListByPdNo(selSpbkList) // 모품번 주문상품목록으로 변환 (주문수량 통합)
      const aditDlvcPlcyList = await this.selAditDlvcPlcyList(spbkSeCd, zip, aditPdList) // 추가배송비정책 목록 조회 - 상품번호(모품번) 기준
      if (this.size(aditDlvcPlcyList) === 0) {
        return
      }

      // 배송비목록 뒤에서부터 추가배송비 엘리먼트 삭제
      for (let i = dlvcList.length - 1; i > 1; i--) {
        dlvcList.splice(i, 1)
      }

      aditDlvcPlcyList.forEach((row) => {
        dlvcList.push({ // 추가배송비
          dlvcKndCd: '02', // 배송비종류코드(CD_00424) [01:기본배송비, 02:상품별배송비, 03:도서산간배송비, 04:반품배송비, 05:교환배송비]
          dlvcPlcyCd: row.dlvcPlcyCd, // 배송비정책코드
          dlvcAm: 0, // 배송비금액
          pdNo: row.pdNo,
          aditDlvcAm: row.aditDlvcAm,
          aditDlvcStdrQy: row.aditDlvcStdrQy
        })
      })

      for (let i = 2; i < dlvcList.length; i++) {
        const aditPd = this.find(aditPdList, { pdNo: dlvcList[i].pdNo })
        if (aditPd.checked && aditPd.prdType === 'PRD_NORMAL') {
          dlvcList[i].dlvcAm = Math.floor(Math.max(aditPd.spbkQy - 1, 0) / dlvcList[i].aditDlvcStdrQy) * dlvcList[i].aditDlvcAm
        } else {
          dlvcList[i].dlvcAm = 0
        }
      }
    },
    computeAllAditDlvc () { // 모든 추가배송비 재계산
      for (let i = 2; i < this.form.dlvcList.length; i++) {
        const aditDlvc = this.form.dlvcList[i]
        const selPdList = this.spbkList.filter((row) => { return row.checked && row.prdType === 'PRD_NORMAL' && row.pdNo === aditDlvc.pdNo }) // 주문가능 온라인 상품 추출
        let spbkQy = 0
        selPdList?.forEach((row) => {
          spbkQy += row.spbkQy
        })

        aditDlvc.dlvcAm = Math.floor(Math.max(spbkQy - 1, 0) / aditDlvc.aditDlvcStdrQy) * aditDlvc.aditDlvcAm
      }
    },
    setOneAditDlvc (spbkPd) { // 장바구니 개별상품 추가배송비 설정
      const aditDlvc = this.find(this.form.dlvcList, { pdNo: spbkPd.pdNo })
      if (aditDlvc) {
        const selPdList = this.spbkList.filter((row) => { return row.checked && row.prdType === 'PRD_NORMAL' && row.pdNo === spbkPd.pdNo }) // 주문가능 온라인 상품 추출
        let spbkQy = 0
        selPdList?.forEach((row) => {
          spbkQy += row.spbkQy
        })

        aditDlvc.dlvcAm = Math.floor(Math.max(spbkQy - 1, 0) / aditDlvc.aditDlvcStdrQy) * aditDlvc.aditDlvcAm
      }
    },
    async pdOrSelList (pdList) { // 상품정보 목록 조회(상품명,썸네일,판매상태 확인)
      return await this.post('/pdo/pdOrSelList', pdList, '상품정보목록 조회', 'pdOrSelList')
    },
    async selOrRcList (pdList) { // 상품정보 목록 조회(상품명,썸네일,판매상태 확인)
      return await this.post('/or/orc/selOrRcList', pdList, '최근 본 상품 상품정보목록 조회', 'selOrRcList')
    },
    async selLimitPdList (pdList) { // 기간내 주문제한 상품 조회
      return await this.post('/or/orc/selLimitPdList', pdList, '기간 내 제한수량 상품정보목록 조회', 'selLimitPdList', true)
    },
    async selPdInfoList (orPdList) { // 주문상품목록에 대한 상품정보 목록을 조회
      const pdNoList = [] // 검색조건 파라미터
      orPdList?.forEach((row) => {
        const index = this.findIndex(pdNoList, { pdNo: row.pdNo })
        if (index === -1) {
          pdNoList.push({ pdNo: row.pdNo }) // PdInfoSelSO
        }
      })

      return await this.pdOrSelList(pdNoList) // 상품정보 목록 (PdInfoSelVO)
    },
    async selLimitPdInfoList (orPdList, pdInfoList) { // 기간 내 최대주문가능수량 제한 상품 목록
      // 코드 02에 해당하는 상품번호 추출
      const pdNoList = [] // 검색조건 파라미터
      const limitPdInfoList = []

      pdInfoList?.forEach((row) => {
        if (row.maxOrPsblCd === '02') {
          pdNoList.push({ pdNo: row.pdNo, onldPdNo: row.onldPdNo, maxOrPsblDcnt: row.maxOrPsblDcnt, maxOrPsblQy: row.maxOrPsblQy })
        }
      })

      orPdList?.forEach((row) => {
        pdNoList.forEach((pd) => {
          if (pd.onldPdNo && pd.onldPdNo === row.onldPdNo) {
            limitPdInfoList.push({ onldPdNo: row.onldPdNo, exhPdNm: row.exhPdNm, spbkQy: row.spbkQy, maxOrPsblDcnt: pd.maxOrPsblDcnt, maxOrPsblQy: pd.maxOrPsblQy, spbkSeCd: row.spbkSeCd })
          } else if (!pd.onldPdNo && pd.pdNo === row.pdNo) {
            limitPdInfoList.push({ onldPdNo: row.onldPdNo, exhPdNm: row.exhPdNm, spbkQy: row.spbkQy, maxOrPsblDcnt: pd.maxOrPsblDcnt, maxOrPsblQy: pd.maxOrPsblQy, spbkSeCd: row.spbkSeCd })
          }
        })
      })
      return await this.selLimitPdList(limitPdInfoList)
    },
    async checkOrPsblYn (orPdList, property, isSelPd) { // 주문가능상품 체크
      let pdInfoList

      if (isSelPd) { // 상품정보 새로조회 true시
        pdInfoList = await this.selPdInfoList(orPdList) // 주문상품목록에 대한 상품정보 목록을 조회
      } else {
        pdInfoList = orPdList
      }

      // 대량주문 > 임시 재고체크 제외 상품
      if (this.spbkSeCd === '04' && this.isSkipOfflCntrStck) {
        console.log('대량주문 재고체크 제외')
        return true
      }

      const unOrCount = pdInfoList?.filter((row) => {
        return row[property] !== 'Y'
      }).length // 주문불가 상품수
      if (unOrCount > 0) {
        await this.alert('주문이 불가한 상품이 포함되어 있습니다. <br>상품 제외 후 주문해주세요.')
        return false
      }

      // 앱 전용 상품
      const appOnlyCount = pdInfoList?.filter((row) => {
        return row.appDdcatPdYn === 'Y'
      }).length // 앱 전용 상품수
      if (appOnlyCount > 0) {
        // 앱 체크
        if (navigator.userAgent.match(/APP_DAISO_Android/i) || navigator.userAgent.match(/APP_DAISO_iOS/i)) {
          // console.log('앱 접속')
        } else {
          await this.alert('앱 전용 상품이 포함되어 있습니다. <br>다이소몰 앱에서 주문해 주세요.')
          return false
        }
      }

      return true
    },
    async checkPdsOrPsblYn (orPdList, property, isSelPd) { // 주문가능상품 체크(일반택배/매장픽업 전용)
      let pdInfoList

      if (isSelPd) { // 상품정보 새로조회 true시
        pdInfoList = await this.selPdInfoList(orPdList) // 주문상품목록에 대한 상품정보 목록을 조회
      } else {
        pdInfoList = orPdList
      }

      const unOrCount = pdInfoList?.filter((row) => { return row[property] !== 'Y' }).length // 주문불가 상품수
      if (unOrCount > 0) {
        await this.alert('주문이 불가한 상품이 포함되어 있습니다. <br>상품 제외 후 주문해주세요.')
        return false
      }

      // 앱 전용 상품
      const appOnlyCount = pdInfoList?.filter((row) => {
        return row.appDdcatPdYn === 'Y'
      }).length // 앱 전용 상품수
      if (appOnlyCount > 0) {
        // 앱 체크
        if (navigator.userAgent.match(/APP_DAISO_Android/i) || navigator.userAgent.match(/APP_DAISO_iOS/i)) {
          // console.log('앱 접속')
        } else {
          console.log('isSelPd', isSelPd)
          if (isSelPd) {
            await this.alert('앱 전용 상품이 포함되어 있습니다.<br>다이소몰 앱에서 주문해 주세요.', {
              okCallback: () => {
                this.$router.push({ name: 'or-orc-SCR_ORC_0001', params: { name: 'tab1' } })
              }
            })
          } else {
            await this.alert('앱 전용 상품이 포함되어 있습니다. <br>다이소몰 앱에서 주문해 주세요.')
          }
          return false
        }
      }

      const limitPdinfList = await this.selLimitPdInfoList(orPdList, pdInfoList) // 기간내 최대주문가능수량 체크
      if (limitPdinfList?.errInfo?.message) {
        await this.$alert(this.replaceHtmlSpcl(limitPdinfList?.errInfo?.message), { center: true, dangerouslyUseHTMLString: true })
        return false
      }
      return true
    },
    setSoldoutAll (spbkList) { // 판매중지 상품외 모든 장바구니 상품 품절처리
      spbkList?.forEach((row) => { // 판매중(품절포함) 상품 모두 품절처리
        row.stck = 0
        if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.prdType !== 'PRD_STRGY') {
          row.prdType = 'PRD_SOLDOUT'
          row.checked = false
        }
        if (row.prdType === 'PRD_STRGY' && row.spbkSeCd !== '01') {
          row.prdType = 'PRD_SOLDOUT'
          row.checked = false
        }
      })

      this.computeOrdPrc()
    },
    async selStctList (spbkSeCd, orPdList, strCd) { // 재고 조회
      let url = '/pdo/selOnlStck'
      let title = '재고조회(온라인)'
      const param = [ // 검색조건 파라미터
        /* 택배배송(01), 정기배송(03) PdOnlStckSO { pdNo: 상품번호, onldPdNo: 온라인전용상품번호 } */
        /* 매장픽업(02), 대량배송(04) PdOfflStckSO { pdNo: 상품번호, strCd: 매장코드 } */
      ]

      if (['01', '03'].includes(spbkSeCd)) { // 택배배송(01), 정기배송(03)인 경우
        orPdList?.forEach((row) => {
          const index = this.findIndex(param, { pdNo: row.pdNo, onldPdNo: row.onldPdNo })
          if (index === -1) {
            param.push({ pdNo: row.pdNo, onldPdNo: row.onldPdNo })
          }
        })
      } else if (['02', '04', '05'].includes(spbkSeCd) && strCd) { // 매장픽업(02), 대량배송(04), 오늘배송(05)인 경우
        if (_.isEmpty(orPdList)) {
          return
        }

        const titleMap = {
          '02': '재고조회(픽업매장)',
          '04': '재고조회(거점매장)',
          '05': '재고조회(오늘배송매장)'
        }
        title = titleMap[spbkSeCd]

        orPdList?.forEach((row) => {
          const index = this.findIndex(param, { pdNo: row.pdNo })
          if (index === -1) {
            const paramItem = { pdNo: row.pdNo, strCd }
            if (spbkSeCd === '05') { // 오늘배송일 경우
              paramItem.cmmnCd = '03'
            }
            param.push(paramItem)
          }
        })

        url = (spbkSeCd === '04') ? '/pdo/selOfflCntrStck' : '/pd/pdh/selStrPkupStck'
      } else {
        return
      }

      return await this.postWithAuth(url, param, title, 'selStctList')
    },
    async postWithAuth (url, param, title, fnNm) {
      const protectedUrls = ['/pd/pdh/selStrPkupStck', '/pdo/selIntPdStDispInfo']
      if (protectedUrls.includes(url)) {
        const tokenRes = await this.$AxiosBuilder.params().build().get('/auth/request')
        const preAuthToken = tokenRes.data
        const randomIV = CryptoJS.lib.WordArray.random(16)
        const encrypted = CryptoJS.AES.encrypt(preAuthToken, CryptoJS.enc.Utf8.parse(process.env.ENCRYPTION_KEY), { iv: randomIV }).toString()
        const encryptedDataWithIv = randomIV.toString(CryptoJS.enc.Base64) + encrypted
        const dmUid = tokenRes.headers['x-dm-uid'] || document.cookie.split('; ').find(c => c.startsWith('DM_UID='))?.split('=')[1] || ''
        return await this.$AxiosBuilder
          .data(param)
          .addHeader('Authorization', 'Bearer ' + encryptedDataWithIv)
          .addHeader('X-DM-UID', dmUid)
          .build()
          .post(url)
          .then((response) => {
            const res = response.data
            if (res?.success) { return res?.data }
            return null
          })
          .catch((e) => { console.debug(e); return null })
      }
      return await this.post(url, param, title, fnNm)
    },
    async checkSpbkStct (spbkSeCd, spbkList, strCd, useYn) { // 장바구니 재고체크
      if (!['04', '05'].includes(spbkSeCd)) {
        this.setSoldoutAll(spbkList) // 판매중지 상품외 모든 장바구니 상품 품절처리
      }

      const stckList = await this.selStctList(spbkSeCd, spbkList, strCd) // 재고 조회
      if (!stckList) {
        this.computeOrdPrc()
        return
      }

      let changedQy = false
      if (['01', '03'].includes(spbkSeCd)) { // 택배배송(01), 정기배송(03)인 경우
        spbkList?.forEach((row) => {
          console.log('택배배송 재고 조회 ==={}', row)
          const stck = this.find(stckList, { pdNo: row.pdNo, onldPdNo: row.onldPdNo })
          row.stck = stck ? stck.stck : 0 // 재고수량
          row.orgStck = stck ? stck.stck : 0
          // 주문수량이 재고수량보다 클 경우 주문수량을 재고수량으로 맞춘다.
          const chgInfo = { autoStckCheck: true }
          if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.prdType !== 'PRD_STRGY' && row.stck > 0 && row.spbkQy > row.stck) {
            // 재고가 최대 주문가능 수량보다 많은지 체크 후 최대 주문가능 수량보다 많다면 최대주문가능수량으로 변경
            if (row.maxOrPsblQy > 0 && row.maxOrPsblQy < row.stck) {
              console.log('type 1 ==={} ? ', row)
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.maxOrPsblQy
              row.spbkQy = row.maxOrPsblQy
              this.changeSpbkQy(chgInfo)
              changedQy = true
            } else {
              // 재고 수량이 최대 주문 가능 수량보다 적을시 장바구니 적재 수량을 재고수량으로 셋팅해준다
              console.log('type 2 ==={} ? ', row)
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.stck
              row.spbkQy = row.stck
              this.changeSpbkQy(chgInfo)
              changedQy = true
            }
          }
          if (row.maxOrPsblQy > 0 && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.prdType !== 'PRD_STRGY' && row.spbkPkgYn !== 'Y' && row.spbkQy > row.maxOrPsblQy) {
            if (row.stck > 0) {
              console.log('type 3 ==={} ? ', row)
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.maxOrPsblQy
              row.spbkQy = row.maxOrPsblQy
              this.changeSpbkQy(chgInfo)
              changedQy = true
            }
          }
          // 덕용상품 장바구니건의 재고 수량체크
          if (row.spbkPkgYn === 'Y' && row.prdType !== 'PRD_STRGY') {
            // 중포 최대구매 가능 수량보다 재고수가 적은 경우, 재고 수량에 가장 근접한 중포 수량으로 설정
            const maxQy = row.jpMaxOrPsblQy * row.jpQy > row.stck ? row.stck : row.jpMaxOrPsblQy * row.jpQy
            if (row.spbkQy > maxQy) {
              const maxJpQy = Math.floor(maxQy / row.jpQy)
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.jpQy * maxJpQy
              row.spbkQy = row.jpQy * maxJpQy
              this.changeSpbkQy(chgInfo)
              changedQy = true
            }
          }

          if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.prdType !== 'PRD_STRGY' && row.spbkQy <= row.stck) { // 재고존재시 판매중 상품으로 변경
            if (spbkSeCd === '01' && row.pdsOrPsblYn === 'Y') {
              // 택배배송일경우 택배배송 가능여부가 Y일때만 재고가 있어도 NORMAL 상태로 변경
              row.prdType = 'PRD_NORMAL'
              row.checked = true
            } else if (spbkSeCd === '03' && row.fdrmOrPsblYn === 'Y') {
              // 정기배송일경우 정기배송 가능여부가 Y일때만 재고가 있어도 NORMAL 상태로 변경
              row.prdType = 'PRD_NORMAL'
              row.checked = true
            }
          }

          // 덕용 상품 장바구니에 상품이 중포 1개 수량보다 적은 경우 OR 덕용상품여부가 변경이 되었을 경우, 품절 처리
          if (row.spbkPkgYn === 'Y' && ((row.jpQy > row.stck)) && row.prdType !== 'PRD_STRGY') {
            row.prdType = 'PRD_SOLDOUT'
          }
        })
      } else if (['02', '04', '05'].includes(spbkSeCd)) { // 매장픽업(02), 대량배송(04), 오늘배송(05)인 경우
        spbkList?.forEach((row) => {
          const stck = this.find(stckList, { pdNo: row.pdNo })
          row.orgStck = stck ? stck.stck : 0
          row.stck = row.spbkSeCd === '05'
            ? Math.min(row.quickMaxOrPsblQy, stck ? stck.stck : 0)
            : row.spbkSeCd === '02'
              ? (stck ? stck.stck : 0)
              : row.massMaxOrPsblQyStdrCd === '02'
                ? row.massMaxOrPsblQy * row.jpQy
                : Math.floor((stck ? stck.stck : 0) / row.jpQy) * row.jpQy
          // 대량배송이고, 상품번호 해당하면 재고 제한 풀어주기
          if (spbkSeCd === '04') {
            const foundItem = this.skipOfflCntrStckPdList.find(item => item.skipCntrPdNo === row.pdNo)
            if (foundItem) {
              row.stck = foundItem.skipCntrStck ? foundItem.skipCntrStck : 500
            }
          }

          const massMinOrQy = Number(row.htrkCnvMummQy) * Number(row.jpQy)
          if (spbkSeCd === '04' && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.prdType !== 'PRD_STRGY' && row.massOrPsblYn === 'Y' && massMinOrQy > 0 && Number(row.stck) < massMinOrQy) {
            row.prdType = 'PRD_SOLDOUT'
            row.checked = false
            return
          }

          const chgInfo = { autoStckCheck: true }
          if (spbkSeCd === '04' && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.massOrPsblYn === 'Y' && Math.floor(row.spbkQy % row.jpQy) !== 0) {
            // 대량배송 장바구니에서 낱개수량이 중포단위에서 벗어날 경우, 가장 근접한 중포 수량으로 변경(용차전환최소수량보다 작을시 용차전환 최소 수량으로 변경)
            const massStckQy = Math.floor(row.spbkQy / row.jpQy) * row.jpQy
            const massMinStckQy = Number(row.htrkCnvMummQy) * row.jpQy
            const massSpbkQy = massStckQy > massMinStckQy ? massStckQy : massMinStckQy
            chgInfo.item = this.cloneDeep(row)
            chgInfo.oldCnt = row.spbkQy
            chgInfo.prdCnt = massSpbkQy
            row.spbkQy = massSpbkQy
            this.changeSpbkQy(chgInfo)
            changedQy = true
          }
          // 주문수량이 재고수량보다 클 경우 주문수량을 재고수량으로 맞춘다.
          if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.spbkPkgYn !== 'Y' && row.stck > 0 && row.spbkQy > row.stck) {
            // 재고가 최대 주문가능 수량보다 많은지 체크 후 최대 주문가능 수량보다 많다면 최대주문가능수량으로 변경

            if (spbkSeCd === '02' || spbkSeCd === '05') {
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.stck
              row.spbkQy = row.stck
              this.changeSpbkQy(chgInfo)
              changedQy = true
            } else if (spbkSeCd === '04' && Math.floor(Number(row.spbkQy) / row.jpQy) > (row.massMaxOrPsblQyStdrCd === '02' ? Number(row.massMaxOrPsblQy) : Math.floor(Number(row.stck) / row.jpQy))) {
              // 대량배송이면서 대량배송 수량이 재고 수량보다 많은 경우만 spbkQy 수정
              console.log('대량배송 stck 확인 ==={}')
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = Math.floor(Number(row.stck) / row.jpQy) * row.jpQy
              row.spbkQy = Math.floor(Number(row.stck) / row.jpQy) * row.jpQy
              this.changeSpbkQy(chgInfo)
              changedQy = true
            }
          }
          if (spbkSeCd === '05' && row.quickMaxOrPsblQy > 0 && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.spbkQy > row.quickMaxOrPsblQy) {
            if (row.stck > 0) {
              console.log('type 4 ==={} ? ', row)
              chgInfo.item = this.cloneDeep(row)
              chgInfo.oldCnt = row.spbkQy
              chgInfo.prdCnt = row.quickMaxOrPsblQy
              row.spbkQy = row.quickMaxOrPsblQy
              this.changeSpbkQy(chgInfo)
              changedQy = true
            }
          }
          // 대량주문 최소수량 보다 장바구니 수량이 적은 경우 최소 수량으로 변경
          if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.stck > 0 && spbkSeCd === '04' && Number(row.htrkCnvMummQy) * row.jpQy > Number(row.spbkQy)) {
            console.log('대량배송 최소수량 변경 ==={} : ', massMinOrQy)
            chgInfo.item = this.cloneDeep(row)
            chgInfo.oldCnt = row.spbkQy
            chgInfo.prdCnt = massMinOrQy
            row.spbkQy = massMinOrQy
            this.changeSpbkQy(chgInfo)
            changedQy = true
          }
          if (spbkSeCd !== '04' && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.spbkQy <= row.stck) { // 재고존재시 판매중 상품으로 변경
            // 매장픽업일경우 매장픽업 가능여부가 Y일때만 재고가 있어도 NORMAL 상태로 변경
            if (spbkSeCd === '02' && row.pkupOrPsblYn === 'Y') {
              row.prdType = 'PRD_NORMAL'
              row.checked = true
              // 오늘배송 가능여부가 Y일때만 normal 상태로 변경하기
            } else if (spbkSeCd === '05' && row.quickOrPsblYn === 'Y') {
              row.prdType = 'PRD_NORMAL'
              row.checked = true
            }
          } else if (spbkSeCd === '04' && row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP' && row.massOrPsblYn === 'Y') { // 대량배송의 경우 재고및 최소용차전환수량보다 커야 판매중 상품으로 변경
            console.log('htrkCnvMummQy === {}', row.htrkCnvMummQy)
            console.log('spbkQy === {}', row.spbkQy)
            console.log('spbkQy === {}', row.stck)
            if (row.spbkQy <= row.stck && row.htrkCnvMummQy <= row.spbkQy) {
              // 대량배송일경우 대량배송 가능여부가 Y일때만 재고가 있어도 NORMAL 상태로 변경
              row.prdType = 'PRD_NORMAL'
              row.checked = true
            }
          }
          // 픽업매장 폐점/휴점 상태일때 장바구니 상품 일시품절처리 및 알림
          if (spbkSeCd === '02' && useYn === 'N') {
            this.$alert('선택하신 매장은 폐점/휴점 매장입니다. <br>다른 매장을 선택해 주세요.', { center: true, dangerouslyUseHTMLString: true })
            spbkList?.forEach((row) => { // 판매중(품절포함) 상품 모두 품절처리
              row.stck = 0
              if (row.prdType !== 'PRD_SELEND' && row.prdType !== 'PRD_SELSTOP') {
                row.prdType = 'PRD_SOLDOUT'
              }
            })
          }
        })
      }

      if (changedQy) {
        await this.$alert('일부 상품의 재고가 부족하여 <br> 주문 가능한 수량으로 변경됩니다.', { dangerouslyUseHTMLString: true })
        changedQy = false
      }
      this.sortSpbkList(spbkList) // 장바구니 상품 정렬
      this.computeOrdPrc()
    },
    sortSpbkList (spbkList) { // 장바구니 상품 정렬
      spbkList.forEach((row) => {
        if (row.pdTy === '04' && row.prdType === 'PRD_NORMAL') { // 굿즈
          row.pdSort = 1
        } else if (row.appDdcatPdYn === 'Y' && row.prdType === 'PRD_NORMAL') {
          row.pdSort = 2
        } else if (row.spbkSeCd === '01' && row.prdStrgyYn === 'Y' && row.prdType === 'PRD_STRGY') {
          row.pdSort = 3
        } else if (row.spbkSeCd === '01' && row.prdStrgyYn === 'Y' && row.prdType === 'PRD_NORMAL') {
          row.pdSort = 4
        } else if (row.prdType === 'PRD_NORMAL' || (row.spbkSeCd !== '01' && row.prdType === 'PRD_STRGY')) {
          row.pdSort = 5
        } else if (row.prdType === 'PRD_SOLDOUT') {
          row.pdSort = 6
        } else if (row.prdType === 'PRD_SELSTOP') {
          row.pdSort = 7
        } else if (row.prdType === 'PRD_SELEND') {
          row.pdSort = 8
        } else {
          row.pdSort = 9
        }
      })
      console.log('spbkList pdSort idx ==={}', spbkList)
      spbkList?.sort((row1, row2) => {
        if (row1.pdSort > row2.pdSort) {
          return 1
        } else if (row1.pdSort < row2.pdSort) {
          return -1
        } else if (row1.frRgDtm < row2.frRgDtm) {
          return 1
        } else if (row1.frRgDtm > row2.frRgDtm) {
          return -1
        }
        return 0
      })
      console.log('spbkList sort ==={}', spbkList)
    },
    fixControl (e) { // [MO] 주문하기 fix
      if (this.fixBottomVisible) {
        this.fixBottomVisible = false
        setTimeout(function () {
          e.target.closest('.fix-btn').nextElementSibling.style.display = 'none'
        }, 500)
      } else {
        e.target.closest('.fix-btn').nextElementSibling.style.display = 'block'
        setTimeout(() => {
          this.fixBottomVisible = true
        }, 1)
      }
    },
    throwEmitAddedSpbk (spbkSeCd) { // 장바구니 추가 성공 emit 이벤트 재발생
      this.$emit('added-spbk', spbkSeCd)
    },
    toGroobeeParam (spbkSeCd, pdList) { // 상품정보로 그루비 파라미터를 생성
      const param = []
      if (!pdList || pdList.length === 0) {
        param.push({
          name: '',
          code: '',
          amt: 0,
          prc: 0,
          salePrc: 0,
          cnt: 0,
          cat: '',
          cateNm: '',
          catL: '',
          cateLNm: '',
          catM: '',
          cateMNm: '',
          catS: '',
          cateSNm: '',
          catD: '',
          cateDNm: '',
          brand: '',
          brandNm: ''
        })
      } else {
        pdList?.forEach((row) => {
          param.push({
            name: row.exhPdNm, // 상품명
            code: row.pdNo, // URL에 표시되는 상품코드
            amt: row.sleUtpc * row.spbkQy, // 상품금액 (할인판매가 X 수량)
            prc: row.sleUtpc, // 판매가 (또는 원가)
            salePrc: row.sleUtpc, // 할인 판매가 (실제 판매가)
            cnt: row.spbkQy, // 수량
            cat: row.optPdYn, // 상품의 카테고리코드
            cateNm: (row.optPdYn === 'Y') ? '옵션' : '단품', // 상품의 카테고리명
            catL: row.exhLCtgrNo, // 상품의 대분류 카테고리코드
            cateLNm: row.exhLCtgrNm, // 상품의 대분류 카테고리명
            catM: row.exhMCtgrNo, // 상품의 중분류 카테고리코드
            cateMNm: row.exhMCtgrNm, // 상품의 중분류 카테고리명
            catS: row.exhSCtgrNo, // 상품의 소분류 카테고리코드
            cateSNm: row.exhSCtgrNm, // 상품의 소분류 카테고리명
            catD: row.optPdYn, // 상품의 세분류 카테고리코드
            cateDNm: (row.optPdYn === 'Y') ? '옵션' : '단품', // 상품의 세분류 카테고리명
            brand: row.brndCd, // 상품의 브랜드코드
            brandNm: row.brndNm // 상품의 브랜드명
          })
        })
      }

      return param
    },
    computeOrdPrc () { // 주문금액 계산
      let cnt = 0
      let sum = 0
      let wght = 0
      this.spbkList?.forEach((row) => {
        if (row.checked && row.prdType === 'PRD_NORMAL' && !(this.spbkSeCd === '01' && row.epieceSleYn === 'N' && row.spbkPkgYn === 'N')) {
          cnt++
          sum += row.sleUtpc * row.spbkQy
          if (this.spbkSeCd === '05') {
            let pdWght = (row.quickWghtStddVal * row.spbkQy) / 1000
            pdWght = Math.round(pdWght * 10) / 10 // 상품무게 소수점 1자리 반올림
            wght = Math.round((wght + pdWght) * 10) / 10 // 상품무게 합산 반올림
          }
        }
      })

      this.$set(this.form, 'orPdCnt', cnt) // 주문상품수
      this.$set(this.form, 'orPdAm', sum) // 주문상품금액
      this.$set(this.form, 'orPdWght', wght) // 주문상품무게

      switch (this.spbkSeCd) {
        case '01': // 택배배송
          this.$set(this.form.dlvcList[0], 'dlvcAm', this.form.orPdAm === 0 || this.form.orPdAm >= this.dlvcPlcy.stdrAm ? 0 : this.dlvcPlcy.bassDlvcAm) // 기본배송비결제액 = 기본배송비
          this.$set(this.form.dlvcList[1], 'dlvcAm', this.form.orPdCnt === 0 ? 0 : this.dlvcPlcy.ismtDlvcAm) // 도서산간배송비결제액 = 도서산간배송비
          break

        case '02': // 매장픽업
          this.$set(this.form.dlvcList[0], 'dlvcAm', this.form.orPdCnt === 0 ? 0 : this.dlvcPlcy.pkupFee) // 기본배송비결제액 = 픽업비수수료
          break

        case '03': // 정기배송
          // this.ableOr = this.form.orPdAm >= this.dlvcPlcy.stdrAm
          this.ableOr = cnt > 0
          break

        case '04': // 대량주문
          this.$set(this.form.dlvcList[0], 'dlvcAm', this.form.orPdCnt === 0 ? 0 : this.dlvcPlcy.htrkDlvcAm) // 기본배송비결제액 = 용차배송비
          break

        case '05': // 오늘배송
          this.$set(this.form.dlvcList[0], 'dlvcAm', this.form.orPdAm === 0 || (this.dlvcPlcy.freeDlvAm > 0 && this.form.orPdAm >= this.dlvcPlcy.freeDlvAm) ? 0 : this.dlvcPlcy.bassDlvcAm) // 기본배송비결제액 = 기본배송비
          this.$set(this.form, 'orWght', wght)
          this.$set(this.form, 'spbkWght', this.form.spbkWght)
          this.$set(this.form, 'stdrAm', this.dlvcPlcy.stdrAm)
          break
      }

      try { // [FO] 결제금액 정보를 장바구니 사이드바로 전송
        const payInfo = this.cloneDeep(this.form)
        delete payInfo.orPdList
        payInfo.spbkSeCd = this.spbkSeCd
        if (this.spbkSeCd === '03') { // 정기배송
          payInfo.ableOr = this.ableOr
        } else if (this.spbkSeCd === '05') { // 오늘배송
          payInfo.ableOr = this.ableQuickDlv
        }

        this.$EventBus.$emit('eb-change-am', payInfo) // 결제예정금액 변경 이벤트 발생
      } catch (e) {
      }
    },
    initChkAllSpbk () { // 장바구니 최초 진입 시 전체선택 체크박스 클릭(품절상품 비활성화 처리)
      for (let i = 0; i < this.spbkList.length; i++) {
        if (['PRD_SOLDOUT', 'PRD_SELEND', 'PRD_SELSTOP'].includes(this.spbkList[i].prdType)) {
          this.$set(this.spbkList[i], 'checked', false)
        } else if (this.spbkList[i].prdType === 'PRD_STRGY' && (this.spbkSeCd === '01' || this.spbkSeCd === '03')) {
          this.$set(this.spbkList[i], 'checked', false)
        } else if (this.spbkList[i].pdChocYn === 'Y') {
          this.$set(this.spbkList[i], 'checked', true)
        } else {
          this.$set(this.spbkList[i], 'checked', false)
          this.chkAllSpbk = false
        }
      }

      if (this.spbkSeCd === '01') { // 택배배송시 추가배송비 재설
        this.computeAllAditDlvc() // 모든 추가배송비 재계산
      }

      this.computeOrdPrc()
    },
    changeChkAllSpbk () { // 장바구니 전체선택 체크박스 클릭
      for (let i = 0; i < this.spbkList.length; i++) {
        // 장바구니 담기시 재고, 품절 여부와 상관없이 체크박스 활성화 해달라는 요청으로
        // 2023.11.12일 체크박스 로직 변경 적용
        this.$set(this.spbkList[i], 'checked', this.chkAllSpbk)

        // if (['PRD_SOLDOUT', 'PRD_SELEND'].includes(this.spbkList[i].prdType)) {
        //   this.$set(this.spbkList[i], 'checked', false)
        // } else {
        //   this.$set(this.spbkList[i], 'checked', this.chkAllSpbk)
        // }
      }
      this.upAllChocPd(this.chkAllSpbk, this.spbkSeCd)

      if (this.spbkSeCd === '01') { // 택배배송시 추가배송비 재설
        this.computeAllAditDlvc() // 모든 추가배송비 재계산
      }

      this.computeOrdPrc()
    },
    changeChkSpbk (spbkNo, checked) { // 장바구니 개별상품 체크박스 클릭
      const spbkPd = this.find(this.spbkList, { spbkNo })
      if (spbkPd) {
        this.$set(spbkPd, 'checked', checked)
        if (!checked) {
          this.chkAllSpbk = false
          this.upChocPd(false, spbkNo)
        } else {
          this.upChocPd(true, spbkNo)
        }

        if (spbkPd.spbkSeCd === '01') { // 택배배송시
          this.setOneAditDlvc(spbkPd) // 장바구니 개별상품 추가배송비 설정
        }

        this.computeOrdPrc()
      }
    },
    rollbackSpbkQy (spbk, newQy, oldQy) { // 장바구니수량 롤백
      this.$set(spbk, 'spbkQy', newQy) // new 수량으로 갱신후 (이부분 누락시 정상갱신이 안됨)
      this.$set(spbk, 'spbkQy', oldQy) // old 수량으로 갱신
    },
    async changeSpbkQy (chgInfo) { // 장바구니 수량 변경
      console.log('changeSpbkQy ==={}', chgInfo)
      const spbkPd = chgInfo.item
      const newQy = chgInfo.prdCnt
      const oldQy = chgInfo.oldCnt

      console.log(' spbkPd ==== {}', spbkPd)

      let maxOrQy = spbkPd.maxOrPsblQy > 0 ? spbkPd.spbkPkgYn === 'Y' ? parseInt(spbkPd.stck) > parseInt(spbkPd.jpMaxOrPsblQy) * parseInt(spbkPd.jpQy) ? parseInt(spbkPd.jpMaxOrPsblQy) * parseInt(spbkPd.jpQy) : parseInt(spbkPd.stck) : Math.min(spbkPd.stck, spbkPd.maxOrPsblQy) : spbkPd.stck
      const massMinOrQy = parseInt(spbkPd.htrkCnvMummQy) * parseInt(spbkPd.jpQy)
      if (this.spbkSeCd === '02') {
        if (spbkPd.massOrPsblYn === 'Y' && parseInt(spbkPd.htrkCnvMummQy) * parseInt(spbkPd.jpQy) > 0) {
          maxOrQy = Math.min(spbkPd.stck, parseInt(spbkPd.htrkCnvMummQy) * parseInt(spbkPd.jpQy) - 1)
        } else {
          maxOrQy = spbkPd.stck
        }
      } else if (spbkPd.spbkSeCd === '04') {
        maxOrQy = spbkPd.massMaxOrPsblQyStdrCd === '02' ? parseInt(spbkPd.massMaxOrPsblQy) * parseInt(spbkPd.jpQy) : spbkPd.stck
      } else if (spbkPd.spbkSeCd === '05') {
        maxOrQy = Math.min(spbkPd.stck, spbkPd.quickMaxOrPsblQy)
      } else if (spbkPd.spbkPkgYn === 'Y') {
        if (parseInt(spbkPd.jpMaxOrPsblQy) * parseInt(spbkPd.jpQy) < spbkPd.stck) {
          maxOrQy = parseInt(spbkPd.jpMaxOrPsblQy) * parseInt(spbkPd.jpQy)
        } else {
          maxOrQy = Math.floor(parseInt(spbkPd.stck) / parseInt(spbkPd.jpQy)) * parseInt(spbkPd.jpQy)
        }
      }

      // 주문 최소수량 체크
      if (this.spbkSeCd === '04' && newQy < massMinOrQy) { // 대량주문 용차전환최소수량 이하시
        if (!chgInfo.autoStckCheck) {
          await this.openToast(parseInt(spbkPd.htrkCnvMummQy) + '박스(' + parseInt(spbkPd.htrkCnvMummQy) * parseInt(spbkPd.jpQy) + '개)부터 구매 가능한 상품입니다.')
        }
        this.rollbackSpbkQy(spbkPd, newQy, oldQy) // 장바구니수량 롤백
        return
      } else if (this.spbkSeCd !== '04' && newQy < 1) {
        const msgStr = spbkPd.spbkPkgYn === 'Y' ? '1박스(' + numberComma(spbkPd.jpQy) + '개)' : '1개'
        await this.openToast(msgStr + '부터 구매 가능한 상품입니다.')
        this.rollbackSpbkQy(spbkPd, newQy, oldQy) // 장바구니수량 롤백
        return
      } else if (!newQy) {
        const msgStr = spbkPd.spbkPkgYn === 'Y' ? '1박스(' + numberComma(spbkPd.jpQy) + '개)' : '1개'
        await this.openToast(msgStr + '부터 구매 가능한 상품입니다.')
        this.rollbackSpbkQy(spbkPd, newQy, oldQy)
        return
      }

      let mvmnResult = -1 // 대량주문 장바구니 이동결과 [-1:이동대상아님, 0:이동취소/실패, 1:이동성공]
      console.log('this.spbkSeCd  ===={}', this.spbkSeCd)

      if ((this.spbkSeCd === '01' || this.spbkSeCd === '02' || this.spbkSeCd === '05') && spbkPd.massOrPsblYn === 'Y') { // 택배배송, 매장픽업(대량주문가능상품)
        mvmnResult = await this.mvmnMassDlvSpbk(spbkPd, newQy, oldQy, maxOrQy) // 대량주문 장바구니로 이동된 경우
      }
      console.log('this.spbkSeCd  ===={}', this.spbkSeCd)
      // 대량배송 장바구니가 아니면서 newQy의 수량이 stck 수량보다 크거나
      const chkValue = (this.spbkSeCd !== '04' && this.spbkSeCd !== '05' && newQy > spbkPd.stck) || (this.spbkSeCd !== '02' && this.spbkSeCd !== '04' && this.spbkSeCd !== '05' && (maxOrQy > 0 && newQy > maxOrQy)) ? 'Y' : 'N'
      console.log('chkValue ==={}', chkValue)
      // spbk, newQy, oldQy, maxOrQy
      if (mvmnResult === 1) { // 대량주문 장바구니 이동 성공
        this.$emit('change', { name: 'tab4' }) // 대량주문 장바구니로 화면 이동
      } else if (chkValue === 'Y') {
        if (this.spbkSeCd === '02' && mvmnResult === -1) { // 매장픽업
          const strNm = chgInfo.strNm ? chgInfo.strNm + ' 매장의' : '설정한 픽업매장의'
          await this.$alert('현재 ' + strNm + ' 재고가 부족합니다. <br> 수령을 희망하는 매장을 변경해 보세요.', { center: true, dangerouslyUseHTMLString: true })
        } else if (this.spbkSeCd !== '02' && mvmnResult === -1) {
          let msgStr = '최대 주문 가능 수량은 '
          msgStr += spbkPd.spbkPkgYn === 'Y' ? maxOrQy + '박스(' + numberComma(maxOrQy * spbkPd.jpQy) + '개) 입니다.' : maxOrQy + '개 입니다.'
          await this.$alert(msgStr)
        }
        if (this.spbkSeCd !== '04') {
          this.rollbackSpbkQy(spbkPd, newQy, oldQy) // 장바구니수량 롤백
        }
      } else if (this.spbkSeCd === '04' && newQy > maxOrQy) { // 체크
        // 대량주문 최대 수량 재고 체크
        await this.$alert('최대 구매 가능 수량은 <br>' + Math.floor(maxOrQy / spbkPd.jpQy) + '박스(' + numberComma(maxOrQy) + '개)입니다.', { center: true, dangerouslyUseHTMLString: true })

        this.rollbackSpbkQy(spbkPd, newQy, oldQy) // 장바구니수량 롤백
      } else if (mvmnResult === -1) {
        const param = {
          spbkNo: spbkPd.spbkNo,
          spbkQy: newQy,
          mbMngNo: this.getMbMngNo()
        }

        const result = await this.post('/or/orc/upSpbkQy', param, '장바구니 수량 변경', 'changeSpbkQy')
        const isOk = result?.row > 0
        console.log('isOK?????', isOk)
        if (isOk) {
          this.$set(spbkPd, 'spbkQy', newQy) // new 수량으로 갱신후 (이부분 누락시 정상갱신이 안됨)

          if (spbkPd.spbkSeCd === '01') { // 택배배송시 개별상품 추가배송비 설정
            this.setOneAditDlvc(spbkPd)
          }

          this.computeOrdPrc()
        } else {
          this.rollbackSpbkQy(spbkPd, newQy, oldQy) // 장바구니수량 롤백
          await this.$alert('장바구니 수량 변경에 실패하였습니다.')
        }
      }
    },
    async mvmnMassDlvSpbk (spbk, newQy, oldQy, maxOrQy) { // 대량주문 장바구니로 이동
      const htrkCnvMummJpQy = this.toNumber(spbk.htrkCnvMummQy) // 용차전환중포최소수량
      const htrkCnvMummQy = this.toNumber(spbk.htrkCnvMummQy * spbk.jpQy) // 용차전환낱개최소수량
      // 기존 if 문 조건, 인풋값이 용차전환 최소수량 전환 보다 클시에 알림문구 출력,
      // 23년 11월 16일 요구사항에 따라 최대구매수량에서 + 혹은 큰 값일 경우 용처 로직 태우도록 변경
      // (spbk.massOrPsblYn === 'Y' && htrkCnvMummQy > 0) && newQy >= htrkCnvMummQy
      // 장바구니 변경 수량이 제품의 수량보다 많을시 예외조건 처리
      if (spbk.massOrPsblYn === 'Y') {
        if ((spbk.maxOrPsblQy > 0 && newQy > maxOrQy) || (htrkCnvMummQy > 0 && newQy >= htrkCnvMummQy)) {
          let strNm
          switch (spbk.spbkSeCd) {
            case '01':
              strNm = '택배배송'
              break
            case '02':
              strNm = '매장픽업'
              break
            case '05':
              strNm = '오늘배송'
              break
          }
          const cntStr = spbk.spbkPkgYn === 'Y' ? Math.floor(maxOrQy / spbk.jpQy) + '박스(' + this.numberComma(maxOrQy) + '개) 입니다.<br>' : maxOrQy + '개 입니다.<br>'
          // X 가능 수량은 최대 N박스(N개)입니다. N박스(N개)부터 대량주문이 가능합니다.
          let msg = strNm + ' 주문 가능 수량은 최대 ' + cntStr
          msg += htrkCnvMummJpQy + '박스(' + htrkCnvMummQy + '개)' + '부터 대량주문이 가능합니다.<br>변경하시겠습니까?'

          return await this.$confirm(msg, '', {
            cancelButtonText: '취소', // 취소
            confirmButtonText: '대량주문하기', // 확인
            dangerouslyUseHTMLString: true
          }).then(async () => {
            const chkSpbkList = []
            const targetSpbk = this.cloneDeep(spbk)
            targetSpbk.spbkQy = htrkCnvMummQy // 장바구니수량을 용차전환최소수량로 설정
            chkSpbkList.push(targetSpbk)
            const result = await this.mvmnSpbk('04', chkSpbkList, 'N', chkSpbkList)

            if (result?.massExist > 0) {
            // 문구 수정 필요
              this.$alert('같은 상품이 장바구니에 이미 담겨 있습니다.<br> 대량주문 장바구니에서 확인해 주세요.', { center: true, dangerouslyUseHTMLString: true })
              this.rollbackSpbkQy(spbk, newQy, oldQy) // 장바구니수량 롤백
              return 0
            } else if (result?.row > 0) {
              return 1 // 대량주문 장바구니 이동 성공
            } else {
              this.rollbackSpbkQy(spbk, newQy, oldQy) // 장바구니수량 롤백
              return 0 // 대량주문 장바구니 이동 실패
            }
          }).catch(() => {
            this.rollbackSpbkQy(spbk, newQy, oldQy) // 장바구니수량 롤백
            return 0 // 대량주문 장바구니 이동 취소
          })
        }
      }

      return -1 // 대량주문 장바구니 이동대상 아님
    },
    async delSpbk (item) { // [FO] 장바구니 상품 목록 1건 삭제
      const delSpbkNoList = [] // 삭제대상 장바구니번호 목록
      delSpbkNoList.push(item.spbkNo)

      await this.delSpbkList(delSpbkNoList)
    },
    async clickSpbkDelBtn () { // 장바구니 선택삭제 버튼 클릭
      const delSpbkNoList = [] // 삭제대상 장바구니번호 목록
      this.spbkList.forEach((row) => {
        if (row.checked === true) {
          delSpbkNoList.push(row.spbkNo)
        }
      })

      if (delSpbkNoList.length === 0) {
        await this.$alert('하나 이상의 상품을 선택해야 합니다.')
        return
      }

      await this.delSpbkList(delSpbkNoList)
    },
    // cancelButtonText: this.$t('취소'),
    // confirmButtonText: this.$t('확인')
    async delSpbkList (delSpbkNoList) { // 장바구니 목록 삭제
      if (await this.confirm('선택한 상품을 삭제하시겠습니까?', { center: true, dangerouslyUseHTMLString: true })) {
        const param = { spbkNoList: delSpbkNoList, mbMngNo: this.getMbMngNo() }
        const result = await this.post('/or/orc/delSpbkList', param, '장바구니 목록 삭제', 'delSpbkList')

        if (this.toNumber(result?.row) > 0) {
          delSpbkNoList.forEach((spbkNo) => { // 화면에서 삭제
            const delSpbkPd = this.find(this.spbkList, { spbkNo })
            if (delSpbkPd?.spbkSeCd === '01') { // 택배배송 장바구니 삭제시 추가배송비 삭
              this.removeElement(this.form.dlvcList, { pdNo: delSpbkPd.pdNo, onldPdNo: delSpbkPd.onldPdNo })
            }

            this.removeElement(this.spbkList, delSpbkPd)
          })

          this.computeOrdPrc()

          if (this.spbkSeCd === '04') { // 대량주문 장바구니 삭제시 배송비 정책 재조회
            this.setMassDlvcPlcyCd()
          }

          this.$emit('change-cont', [{ spbkSeCd: this.spbkSeCd, spbkCont: this.spbkList.length }]) // 장바구니별 건수 변경
        } else {
          await this.$alert('장바구니 삭제에 실패하였습니다.')
        }
      }
    },
    async selMbInfo (mbInfo) { // 회원정보 조회
      const result = await this.post('/mb/mbc/selMbInfo', { mbMngNo: this.getMbMngNo() }, '회원정보 조회', 'selMbInfo')
      this.$set(mbInfo, 'invdMb', result?.invdMb)
      this.$set(mbInfo, 'pkupStr', result?.pkupStr)
      this.$set(mbInfo, 'rectChnl', result?.rectChnl)
      this.$set(mbInfo, 'svrsYn', result?.svrsYn)
    },
    toOrdForm (mbInfo) { // 회원정보에서 주문자 정보 추출
      return {
        ordNm: mbInfo.invdMb.mbEfnm, // 주문자명
        ordCrryTno: mbInfo.invdMb.empno, // 주문자 휴대전화번호
        ordEml: mbInfo.invdMb.eeml // 주문자 이메일
      }
    },
    async mvmnSpbk (spbkSeCd, spbkList, spbkDelYn, originSpbkList) { // 장바구니 이동
      const param = {
        spbkSeCd,
        spbkList,
        spbkDelYn,
        originSpbkList,
        chnlCd: this.getChnlCd(), // 채널코드
        orMdiaCd: this.getMdiaSeCd(), // 주문매체코드
        mbMngNo: this.getMbMngNo()
      }

      return await this.post('/or/orc/mvmnSpbk', param, '장바구니 이동', 'mvmnSpbk')
    },
    clickSpbkOptChgBtn (spbkNo) { // [미사용] 장바구니 옵션선택 버튼 클릭
      const spbk = this.find(this.spbkList, { spbkNo })
      this.optSpbk = this.cloneDeep(spbk)
      this.popupType = 'optChg' // 옵션변경 팝업
    },
    async changeSpbkOpt (optForm) { // [미사용] 장바구니 옵션 변경
      const { spbkNo, onldPdNo, spbkQy, optCn } = optForm

      const spbk = this.find(this.spbkList, { spbkNo })
      if (spbk?.onldPdNo === onldPdNo && spbk?.spbkQy === spbkQy) { // 옵션 변경이 안된 경우
        return
      }

      // 화면정보 수정
      spbk.onldPdNo = onldPdNo
      spbk.optCn = optCn
      spbk.spbkQy = spbkQy

      const param = { spbkNo, onldPdNo, spbkQy }
      await this.post('/or/orc/upSpbkOpt', param, '장바구니 옵션변경', 'changeSpbkOpt')

      this.computeOrdPrc()
    },
    async clickWrhNtcnBtn (ntcnSpbk) { // [미사용] 재입고 알림 버튼 클릭
      if (ntcnSpbk.ancSeq) { // 이미 재입고 알림 신청한 경우
        this.$notify.closeAll()
        this.popupType = 'none'

        this.$notify({
          message: '재입고알림 신청이 해제되었습니다.',
          position: 'bottom-right',
          showClose: false,
          center: true,
          dangerouslyUseHTMLString: true,
          onClick: () => { this.$notify.closeAll() },
          onClose: () => { this.popupType = 'none' }
        })

        return
      }

      // 재입고 알림 신청안한 경우
      const param = {
        pdNo: ntcnSpbk.pdNo, // 상품번호
        // onldPdNo: ntcnSpbk.onldPdNo, // 온라인전용상품번호
        ancTy: '02', // 알람유형[01:판매예정상품신청알람, 02:재입고신청알람]
        mbMngNo: this.getMbMngNo() // 회원관리번호
      }

      const paramList = []
      paramList.push(param)

      const result = await this.post('/pdo/ancRqRls', paramList, '재입고알림 신청', 'clickWrhNtcnBtn')
      if (result?.ancSeq) { // 재입고 알림 신청이 성공해 알람순번을 리턴받은 경우
        const spbk = this.find(this.spbkList, { spbkNo: ntcnSpbk.spbkNo })
        spbk.ancSeq = result.ancSeq
        this.popupType = 'none'
        this.$notify({
          message: '재입고알림 신청이 완료되었습니다.',
          position: 'bottom-right',
          showClose: false,
          center: true,
          dangerouslyUseHTMLString: true,
          onClick: () => { this.$notify.closeAll() },
          onClose: () => { this.popupType = 'none' }
        })
      }
    },
    async selBassDvya () { // 기본배송지 조회
      const devy = await this.post('/or/orc/selBassDvya', { mbMngNo: this.getMbMngNo() }, '기본배송지 조회', 'selBassDvya')

      if (devy) {
        return {
          dvyaSeq: devy?.dvyaSeq, // 배송지순번
          bassDvyaYn: devy?.bassDvyaYn, //  기본배송지여부
          dvyaNm: this.unescape(devy?.dvyaNm), //  배송지명
          addrZip: devy?.addrZip, //  우편번호
          addrBassEaddr: this.unescape(devy?.addrBassEaddr), //  기본주소
          dtlEaddr: this.unescape(devy?.dtlEaddr), //  상세주소
          rcpmEfnm: this.unescape(devy?.rcpmEfnm), //  수령인명
          rcpmCntp1Etno: devy?.rcpmCntp1Etno, //  수령인연락처1
          rqstTy: devy?.rqstTy, // 요청유형
          rqstMtr: this.unescape(devy?.rqstMtr) // 요청사항
        }
      }
    },
    async selBassPkupStr () { // 기본픽업매장 조회
      return await this.post('/or/orc/selBassPkupStr', { mbMngNo: this.getMbMngNo() }, '기본픽업매장 조회', 'selBassPkupStr')
    },

    // //////////////////////////////////////////////////////////////
    // 주문서 작성 공통
    async selDvyaList () { // 배송지목록 조회
      const param = { mbMngNo: this.getMbMngNo() }
      return await this.post('/mb/mbc/selDvya', param, '배송지목록 조회', 'selDvyaList')
    },
    async clickDvyaChgBtn (spbkSeCd, opt) { // 배송지 [변경] 버튼 클릭 - 배송지 선택 팝업 오픈
      if (!this.getMbMngNo()) { // 로그인 안했을때
        if (await this.confirm(this.$t('SM.LOGIN'))) {
          this.$router.push({ path: '/mb/mbb/SCR_MBB_0097A' })
        }

        return
      }

      if (spbkSeCd === '04' && opt?.dlvFomCd) { // 대량배송시
        if (opt?.dlvFomCd === '03') {
          if (await this.confirm('대량주문 배송지 변경 시<br>주문 가능 수량이 달라질 수 있습니다.<br><span class="desc">※ 배송지 변경은 장바구니에서 가능합니다.</span>', { customClass: 'md' })) {
            this.$router.push({ name: 'or-orc-SCR_ORC_0001', params: { name: 'tab4' } })
          }
        } else if (await this.confirm('대량배송 픽업매장은 설정한 배송지에서 가까운 거점매장으로 자동 지정됩니다.<br><span class="desc">* 배송지 변경은 장바구니에서 가능합니다.</span>', { customClass: 'md' })) {
          this.$router.push({ name: 'or-orc-SCR_ORC_0001', params: { name: 'tab4' } })
        }
      } else if (spbkSeCd === '05' && opt?.dlvFomCd) { // 오늘배송시
        this.$commonMsgbox.confirm('배송지 변경 시<br> 주문 가능 수량이 달라질 수 있습니다.<br><span class="desc">※ 배송지 변경은 장바구니에서 가능합니다.</span>', '', {
          confirmButtonText: '장바구니로 이동',
          cancelButtonText: '취소',
          center: true,
          dangerouslyUseHTMLString: true,
          customClass: 'md'
        }).then(() => {
          this.$router.push({ name: 'or-orc-SCR_ORC_0001', params: { name: 'tab5' } })
        }).catch(() => {
        })
      } else if (opt?.isEmit) {
        this.$emit('popup-dvya')
        return
      }

      this.openDvyaChgPpup()
    },
    openDvyaChgPpup () {
      if (this.has(this.$refs.dvyaChgPpup, 'dialogFormVisible')) { // [MO]
        this.$refs.dvyaChgPpup.dialogFormVisible = true
      } else if (this.has(this.$refs.dvyaChgPpup, 'outerVisible')) { // [FO]
        this.$refs.dvyaChgPpup.outerVisible = true
      }
    },
    closeDvyaChgPpup () { // 배송지 선택 팝업 close
      if (this.has(this.$refs.dvyaChgPpup, 'dialogFormVisible')) { // [MO]
        this.$refs.dvyaChgPpup.dialogFormVisible = false
      } else if (this.has(this.$refs.dvyaChgPpup, 'outerVisible')) { // [FO]
        this.$refs.dvyaChgPpup.outerVisible = false
      }
    },
    changeDvya (data) { // 배송지 선택 변경 emit 처리
      console.log('<<< 배송지 변경::', data)
      if (!this.dvya) {
        this.dvya = {}
      }

      this.$set(this.dvya, 'dvyaSeq', data?.dvyaSeq) // 배송지순번
      this.$set(this.dvya, 'bassDvyaYn', data?.bassDvyaYn) // 기본배송지여부
      this.$set(this.dvya, 'dvyaNm', this.unescape(data?.dvyaNm)) // 배송지명
      this.$set(this.dvya, 'addrZip', data?.addrZip) // 우편번호
      this.$set(this.dvya, 'addrBassEaddr', this.unescape(data?.addrBassEaddr)) // 기본주소
      this.$set(this.dvya, 'dtlEaddr', this.unescape(data?.dtlEaddr)) // 상세주소
      this.$set(this.dvya, 'rcpmEfnm', this.unescape(data?.rcpmEfnm)) // 수령인명
      this.$set(this.dvya, 'rcpmCntp1Etno', data?.rcpmCntp1Etno) // 수령인연락처1
      this.$set(this.dvya, 'rqstTy', data?.rqstTy) // 요청유형
      this.$set(this.dvya, 'rqstMtr', this.unescape(data?.rqstMtr)) // 요청사항

      this.$EventBus.$emit('eb-after-change-dvya', { zip: data?.addrZip, spbkSeCd: this.spbkSeCd || this.form?.spbkSeCd }) // 배송지변경 후처리 이벤트 발생
    },
    openStrChgPpup () { // 픽업매장 변경 팝업 open
      this.$refs.strChgPpup.selPkupStrList()
      this.$refs.strChgPpup.selGeolocationAgrYn()
      this.$refs.strChgPpup.outerVisible = true
      // if (!this.getMbMngNo()) { // 로그인 안했을때
      //   if (await this.confirm(this.$t('SM.LOGIN'))) {
      //     this.$router.push({ path: '/mb/mbb/SCR_MBB_0097A' })
      //   }

      //   return
      // }
      // this.$confirm('픽업 매장에 따라 재고가 달라질 수 있습니다. 픽업 매장을 변경하시겠습니까?', '', {
      //   confirmButtonText: '확인',
      //   cancelButtonText: '취소',
      //   center: true,
      //   dangerouslyUseHTMLString: true
      // }).then(() => {
      //   this.$refs.strChgPpup.outerVisible = true
      // }).catch(() => {
      // })
    },
    closeStrChgPpup () { // 픽업매장 변경 팝업 close
      this.$refs.strChgPpup.outerVisible = false
    },
    changeStr (data) { // 픽업매장 변경 emit 처리
      console.log('<<< 픽업매장 변경::', data)
      if (!this.pkupStr) {
        this.pkupStr = {}
      }

      this.$set(this.pkupStr, 'strNknmNm', this.unescape(data?.strNknmNm)) // 매장별칭명
      this.$set(this.pkupStr, 'strCd', data?.strCd) // 매장코드
      this.$set(this.pkupStr, 'strNm', this.unescape(data?.strNm)) // 매장명
      this.$set(this.pkupStr, 'bassPkupStrYn', data?.bassPkupStrYn) // 기본픽업매장여부
      this.$set(this.pkupStr, 'strZip', data?.strZip) // 매장우편번호
      this.$set(this.pkupStr, 'strAddr', this.unescape(data?.strAddr)) // 매장주소
      this.$set(this.pkupStr, 'strDtlAddr', this.unescape(data?.strDtlAddr)) // 매장상세주소
      this.$set(this.pkupStr, 'strTno', data?.strTno) // 매장전화번호
      this.$set(this.pkupStr, 'opngTime', data?.opngTime) // 개점시각
      this.$set(this.pkupStr, 'clsngTime', data?.clsngTime) // 폐점시각
      this.$set(this.pkupStr, 'useYn', data?.useYn) // 사용유무
      this.$set(this.pkupStr, 'pkupYn', data?.pkupYn) // 픽업가능여부
      this.$set(this.pkupStr, 'bsnSspYn', data?.bsnSspYn) // 영업중단여부
      localStorage.setItem('pkupStr', JSON.stringify(this.pkupStr))
      this.$EventBus.$emit('eb-after-change-dvya', { strCd: data?.strCd, strNm: this.unescape(data?.strNm), spbkSeCd: this.spbkSeCd, pkupYn: data?.pkupYn, useYn: data?.useYn, bsnSspYn: data?.bsnSspYn, strAddr: this.unescape(data?.strAddr), strDtlAddr: this.unescape(data?.strDtlAddr), opngTime: data?.opngTime, clsngTime: data?.clsngTime }) // 배송지변경 후처리 이벤트 발생
    },
    getDlvcSumAm (dlvcList) { // 총배송비 금액 조회
      let dlvcSumAm = 0
      dlvcList?.forEach((row) => {
        dlvcSumAm += row.dlvcAm
      })
      return dlvcSumAm
    },
    getBassDlvcAm (dlvcList) { // 기본배송비 금액 조회
      return (dlvcList?.length > 0) ? dlvcList[0].dlvcAm : 0
    },
    getAddDlvcAm (dlvcList) { // 추가배송비 금액 조회
      let dlvcSumAm = 0
      for (let i = 1; i < dlvcList?.length; i++) {
        dlvcSumAm += dlvcList[i].dlvcAm
      }
      return dlvcSumAm
    },
    getPgPyAm (payInfo) { // PG결제금액 조회
      // 주문상품금액(orPdAm) + 배송비금액(dlvcAm) - 상품권사용금액(gfUseAm) - 포인트사용금액(pntUseAm) - 적립금사용금액(acmyUseAm) - 쿠폰할인금액(cpnDctAm)
      const pgPyAm = this.toNumber(payInfo?.orPdAm) + this.toNumber(payInfo?.dlvcAm) - this.toNumber(payInfo?.gfUseAm) - this.toNumber(payInfo?.pntUseAm) - this.toNumber(payInfo?.acmyUseAm) - this.toNumber(payInfo?.cpnDctAm)
      return Math.max(pgPyAm, 0) // [(주문상품금액+배송비금액) < 쿠폰할인금액] 경우 마이너스 금액 방지
    },
    getPdCpnDctAm (dctCpnList) { // 상품쿠폰할인금액
      let pdCpnDctAm = 0

      dctCpnList?.forEach((row) => {
        if (row.cpnKndCd === '01') { // 쿠폰종류코드(CD_00065) [01:상품쿠폰, 02:장바구니쿠폰, 03:적립금쿠폰, 04:배송비쿠폰, 05:이벤트쿠폰]
          pdCpnDctAm += row.maxDctAm
        }
      })

      return pdCpnDctAm
    },
    getBuyAm (payInfo) { // 구매금액 조회
      // 주문상품금액(orPdAm) - 포인트사용금액(pntUseAm) - 적립금사용금액(acmyUseAm) - 상품쿠폰할인금액
      const buyAm = this.toNumber(payInfo?.orPdAm) - this.toNumber(payInfo?.pntUseAm) - this.toNumber(payInfo?.acmyUseAm) - this.getPdCpnDctAm(payInfo?.dctCpnList)
      return Math.max(buyAm, 0)
    },
    async selOrdInfo () { // 주문자정보 조회
      return await this.post('/or/ora/selOrdInfo', { mbMngNo: this.getMbMngNo() }, '주문자정보 조회', 'selOrdInfo')
    },
    setOrFormParams () { // 주문서 this.params 설정
      const params = this.$route.params
      console.log('<<< setOrFormParams::$route.params', params)
      if (params?.orPdList?.length > 0) { // 이전 페이지가 장바구니/바로구매인 경우
        this.params = params
        this.params.no = (new Date()).getTime().toString() // 임시번호 발급

        // tab 파라미터만 보존하며 no 업데이트
        const tabValue = new URLSearchParams(window.location.search).get('tab')
        const newUrl = new URL(window.location.origin + window.location.pathname)
        if (tabValue) {
          newUrl.searchParams.set('tab', tabValue)
        }
        newUrl.searchParams.set('no', this.params.no)
        history.replaceState(null, null, newUrl.pathname + newUrl.search)

        localStorage.setItem('orFormStore', JSON.stringify(this.params))

        console.log('<<< setOrFormParams::$nuxt.context.from', this.$nuxt.context?.from)

        let orBackPath
        if (['/or/orc/SCR_ORC_0001', '/bp/bpa/SCR_BPA_0001'].includes(this.$nuxt.context?.from?.path)) {
          orBackPath = '/or/orc/SCR_ORC_0001?tab=' + this.form.spbkSeCd
        } else {
          orBackPath = this.$nuxt.context?.from?.fullPath
        }
        localStorage.setItem('orBackPath', orBackPath) // 뒤로가기 경로
      } else { // 새로고침시
        const query = this.$route.query
        console.log('<<< setOrFormParams::$route.query', query)
        if (query?.no) {
          const orFormStore = JSON.parse(localStorage.getItem('orFormStore'))
          if (query.no === orFormStore?.no) {
            this.params = orFormStore
          }
        }
      }

      return this.params
    },
    async selOrFormInptDta (form) { // 주문서 입력자료 조회 (주문자정보설정, 적립혜택설정)
      const orFormEntrDtm = new Date(new Date().getTime() + (9 * 60 * 60 * 1000)).toISOString().replace('Z', '') // 주문서 진입 시점 저장 (한국시간)
      const param = {
        mbMngNo: this.getMbMngNo(), // 회원관리번호
        userTy: this.getUserTy(),
        spbkSeCd: form.spbkSeCd, // 장바구니구분코드
        orPdList: form.orPdList, // 주문상품 목록
        mdiaSeCd: this.getMdiaSeCd(), // 매체구분코드(CD_00198) [10:PC, 20:모바일웹, 30:모바일앱]
        zip: form.zip, // 기본배송지,이번만배송지 우편번호
        orFormEntrDtm // 주문서 진입 시점
      }
      form.orFormEntrDtm = orFormEntrDtm // form에도 저장

      const inptDta = await this.post('/or/ora/selOrFormInptDta', param, '주문서 입력자료 조회', 'selOrFormInptDta', true)

      if (inptDta.errInfo?.extraData.errCd === 'OR_20') {
        await this.$alert('동일 상품을 중복 주문할 수 없습니다.<br>장바구니에서 제거 후 주문해 주세요.<br>상품: ' + inptDta.errInfo.extraData.pdNm, { center: true, dangerouslyUseHTMLString: true })
        this.$router.push('/or/ORC/SCR_ORC_0001?tab=' + param.spbkSeCd)
        return inptDta
      }
      if (inptDta.errInfo?.extraData.errCd === 'MB_11') {
        await this.$alert('회원정보가 올바르지 않습니다.<br>고객센터(1599-2211)에 문의해주세요.', { center: true, dangerouslyUseHTMLString: true })
        this.$router.push('/or/ORC/SCR_ORC_0001?tab=' + param.spbkSeCd)
        return inptDta
      }

      // 쿠폰적용목록(cpnAplList)에 장바구니번호 추가
      inptDta?.cpnAplList?.forEach((row) => {
        const pd = this.find(form.orPdList, { pdNo: row.pdNo })
        if (pd) {
          row.spbkNo = pd.spbkNo
        }
      })

      let msAcmyMumm = 0
      inptDta?.msAcmyMumm?.forEach((row) => {
        msAcmyMumm += row.acmyAmnt
      })

      if (inptDta?.acmyBlce != null) {
        inptDta.useAcmyBlce = inptDta.acmyBlce - msAcmyMumm
      }

      // 주문자정보 설정
      form.ordNm = inptDta.ordInfo.ordNm // 주문자명
      form.ordCrryTno = inptDta.ordInfo.ordCrryTno // 주문자 휴대전화번호
      form.ordEml = inptDta.ordInfo.ordEml // 주문자 이메일

      this.setAcmBnf(inptDta, form) // 적립혜택설정

      return inptDta
    },
    setAcmBnf (inptDta, form) { // 적립혜택설정
      form.acmBnfList = inptDta?.acmBnfList // 적립혜택목록 추가

      form.acmBnfList?.forEach((row) => {
        if (row.adiCstDtlTyCd === '28') { // 부가비용상세유형코드 = 리뷰적립
          form.acmBnf.maxRevwAcmy = row.acmy // 최대리뷰적립금
        } else if (['24', '25', '26', '27'].includes(row.adiCstDtlTyCd)) {
          form.acmBnf.evtAcmy += row.acmy // 이벤트적립금(합)
        }
      })

      inptDta?.cpnAplList?.forEach((row) => {
        if (row.spyMthCd === '02') { // 쿠폰제공방법코드 = 적립(02)
          form.acmBnf.cpnAcmy += row.acmy // 쿠폰적립금(합)
        }
      })
    },
    setBuyAcmy () { // 구매적립금 설정
      if (this.form.acmBnfList.length > 0) {
        const buyAm = this.getBuyAm(this.payInfo) // 구매금액
        const pntBuyAcmy = Math.floor(buyAm * this.form.acmBnfList[0].acmRt / 100) // 포인트구매적립금
        this.form.acmBnf.pntBuyAcmy = pntBuyAcmy
        this.form.acmBnfList[0].acmy = pntBuyAcmy
      }
    },
    changePymtAm (payInfo) { // 결제수단 결제금액 변경 emit 수신
      switch (payInfo.pymtCd) { // 결제수단
        case '50': // 다이소상품권
          this.payInfo.gfUseAm = payInfo.useAm
          break
        case '60': // 포인트
          this.payInfo.pntUseAm = payInfo.useAm
          break
        case '70': // 적립금
          this.payInfo.acmyUseAm = payInfo.useAm
          break
      }

      this.setBuyAcmy() // 구매적립금 설정
    },
    async checkOrFormStct (spbkSeCd, orPdList, strCd) { // 주문서 재고체크
      const stckList = await this.selStctList(spbkSeCd, orPdList, strCd) // 재고 조회
      const pdList = ['01', '03'].includes(spbkSeCd) ? orPdList : this.toPdListByPdNo(orPdList) // 매장픽업(02), 대량배송(04), 오늘배송(05)인 경우 모품번 기준 재고체크

      let isSoldout = false
      const soldoutPdNmList = []
      if (['01', '03'].includes(spbkSeCd)) { // 택배배송(01), 정기배송(03)인 경우 자품번 기준 재고체크
        for (let i = 0; i < pdList.length; i++) {
          const stck = this.find(stckList, { pdNo: pdList[i].pdNo, onldPdNo: pdList[i].onldPdNo })
          if (!stck || pdList[i].spbkQy > stck.stck) {
            isSoldout = true
            break
          }
        }
      } else if (spbkSeCd === '04') { // 대량배송(04)인 경우 모품번 기준 재고체크
        for (let i = 0; i < pdList.length; i++) {
          const stck = this.find(stckList, { pdNo: pdList[i].pdNo })
          if (!stck || pdList[i].spbkQy > stck.stck) {
            isSoldout = true
            soldoutPdNmList.push(pdList[i].exhPdNm)
            break
          }
        }
        await this.selSkipCntrStckList()
        if (this.isSkipOfflCntrStck) {
          console.log('대량배송 재고체크 제외로 인한 품절 미처리')
          isSoldout = false
        }
      } else if (spbkSeCd === '02') { // 매장픽업(02)인 경우 모품번 기준 재고체크
        for (let i = 0; i < pdList.length; i++) {
          const stck = this.find(stckList, { pdNo: pdList[i].pdNo })
          if (!stck || pdList[i].spbkQy > stck.stck) {
            isSoldout = true
            soldoutPdNmList.push(pdList[i].exhPdNm)
          }
        }
      }

      if (isSoldout) {
        if (spbkSeCd === '02' || spbkSeCd === '05') {
          await this.$alert('재고가 부족한 상품이 있습니다.<br>주문 수량을 다시 확인해 주세요.<br>상품: ' + Array.from(soldoutPdNmList).join(', '), { center: true, dangerouslyUseHTMLString: true })
        } else {
          await this.$alert('주문이 불가한 상품이 포함되어 있습니다. <br>상품 제외 후 주문해주세요.', { center: true, dangerouslyUseHTMLString: true })
        }

        this.$router.push('/or/ORC/SCR_ORC_0001?tab=' + spbkSeCd)
        return false
      }

      return true
    },
    changeAplCpn (cpnDct) { // 적용쿠폰 변경 emit 수신
      this.payInfo.cpnDctAm = cpnDct.cpnDctAm
      this.payInfo.dctCpnList = cpnDct.dctCpnList
      this.setBuyAcmy() // 구매적립금 설정
    },
    setCpnForm () { // 쿠폰 선택 폼 설정
      this.removeAll(this.cpnForm.cpnAplList)
      this.inptDta?.cpnAplList.forEach((row) => {
        this.cpnForm.cpnAplList.push({ pdNo: row.pdNo, cpnNo: row.cpnNo, cpnIssuNo: row.cpnIssuNo })
      })

      this.removeAll(this.cpnForm.orPdList)
      this.form?.orPdList.forEach((row) => {
        const orPd = this.find(this.cpnForm.orPdList, { pdNo: row.pdNo })
        if (orPd) {
          orPd.orAm += this.toNumber(row.sleUtpc) * this.toNumber(row.spbkQy)
        } else {
          this.cpnForm.orPdList.push({ pdNo: row.pdNo, orAm: this.toNumber(row.sleUtpc) * this.toNumber(row.spbkQy) })
        }
      })

      this.cpnForm.fstBuyYn = this.inptDta?.fstBuyYn === 'Y' ? 'Y' : '' // 첫구매여부
      this.cpnForm.reBuyYn = this.inptDta?.reBuyYn === 'Y' ? 'Y' : '' // 재구매여부
      this.cpnForm.stdrAm = this.params?.stdrAm ? this.params?.stdrAm : this.cpnForm?.stdrAm// 무료배송 주문상품금액
      this.cpnForm.freeDlvAm = this.params?.freeDlvAm ? this.params?.freeDlvAm : this.cpnForm?.freeDlvAm// (오늘배송)무료배송 주문상품금액
      this.cpnForm.orAmSum = this.payInfo.orPdAm // this.form.orPdAm 값 설정시 0으로 바뀌는 증상 있음
    },
    openCpnPpup () {
      this.setCpnForm() // 쿠폰 선택 폼 설정
      console.log('쿠폰 선택 팝업::cpnForm', this.cpnForm)
      this.popupType = 'selCpn'
    },
    closeCpnPpup (data) { // 쿠폰 선택 팝업창 close
      this.popupType = 'none'

      if (data?.type === 'apply') {
        console.log('<<< 쿠폰 선택 팝업::newCpnList', data?.newCpnList)
        this.removeAll(this.inptDta.cpnAplList)
        data?.newCpnList.forEach((row) => {
          this.inptDta.cpnAplList.push(row)
        })
      }

      this.setCpnForm()
    },
    async selGfBlce () { // 상품권 잔액 조회
      const gfBlce = await this.post('/or/ora/selGfBlce', null, '상품권 잔액 조회', 'selGfBlce')
      this.inptDta.gfBlce = this.toNumber(gfBlce)
    },
    openTrmPpup (trmId) { // 약관보기 팝업 open
      this.popupType = 'trm'
      this.trm = this.find(this.inptDta.trmList, { trmId })
    },
    async validateOrForm (refIdList) { // 주문서 유효성 검사
      let isOk = this.validateRefIdList(refIdList)
      if (isOk) {
        isOk = await this.$refs.orTerms.validate() // 약관동의 유효성 검사
        if (!isOk) {
          this.scrollToRef(this.$refs.orTerms) // 약관동의 폼으로 스크롤
        }
      }

      return isOk
    },
    validateRefIdList (refIdList) {
      const validateList = []

      for (let i = 0; i < refIdList.length; i++) {
        const ref = this.$refs[refIdList[i]]
        if (this.isFunction(ref.validate)) {
          const isOk = ref.validate() // 폼 유효성 검사
          validateList.push(isOk)
          if (!isOk) {
            console.log('validateRefIdList::invalid', refIdList[i])
            break
          }
        } else {
          validateList.push(true)
        }
      }

      const index = validateList.indexOf(false)
      if (index > -1) { // 유효성 검사 오류 폼이 존재하면 오류폼으로 스크롤
        this.scrollToRef(this.$refs[refIdList[index]])
        return false
      }

      return true
    },
    async insOrForm (form) { // 주문서정보 DB 저장
      const result = await this.post('/or/ora/insOrForm', form, '주문서 저장', 'insOrForm', true)
      if (result?.rsltCd !== 'OK') {
        if (result?.errInfo?.returnCode === 'OR_1C') {
          await this.$alert('배송비 쿠폰을 적용할 수 없습니다.')
        } else {
          await this.$alert('주문하기에 실패하였습니다.')
        }
      }

      return result
    },
    setPgPayLayout () { // [FO] PG 결제창 크기 설정
      switch (this.pyForm.pymtCd) {
        case '33': // 삼성페이
          this.pgPayLayout.width = '400px'
          this.pgPayLayout.height = '644px'
          this.pgPayLayout.radius = '5px'
          this.pgPayLayout.class = 'pg-pay-samsung'
          break
        case '30': // 네이버페이
          this.pgPayLayout.width = '378px'
          this.pgPayLayout.height = '478px'
          this.pgPayLayout.radius = '20px'
          this.pgPayLayout.class = 'pg-pay-naver'
          break
        case '31': // 카카오페이
          this.pgPayLayout.width = '420px'
          this.pgPayLayout.height = '514px'
          this.pgPayLayout.radius = '5px'
          this.pgPayLayout.class = 'pg-pay-kakao'
          break
        case '32': // 페이코
        case '34': // 토스페이
        case '35': // 애플페이
          this.pgPayLayout.width = '440px'
          this.pgPayLayout.height = '633px'
          this.pgPayLayout.radius = '5px'
          this.pgPayLayout.class = 'pg-pay'
          break
        default:
          this.pgPayLayout.width = '650px'
          this.pgPayLayout.height = '650px'
          this.pgPayLayout.radius = '20px'
          this.pgPayLayout.class = 'pg-default'
          break
      }
    },
    async openPgPay (pyForm) { // PG 결제창 오픈
      const pyParam = this.getPyRqstParam(pyForm)

      console.log('openPgPay::pymtCd', pyForm.pymtCd)
      const pymtCd = String(pyForm.pymtCd || '').trim()
      const inicisPayPymtCdList = ['10', '20', '21', '30', '31', '32', '33', '34', '35', '36', '40']
      if (await this.isInicisPayTarget(pymtCd) && inicisPayPymtCdList.includes(pymtCd)) {
        return await this.openInicisPay(pyForm)
      }
      // 공통코드 CD_00631(결제대행사전환여부) 조회 - 하위코드값: Y=토스, N=이니시스
      // const pgCdMap = await this.selCdMap(['CD_00631'])
      // const pgCdList = pgCdMap?.CD_00631 || []
      // const useToss = pgCdList.length > 0 ? pgCdList[0].cmmnCd : 'Y'
      // console.log('openPgPay::useToss', useToss)
      // if (useToss !== 'Y' && ['10', '20', '21', '30', '31', '32', '33', '34', '35', '40'].includes(pyForm.pymtCd)) {
      //   console.log('>>> 이니시스 결제 시작')
      //   return await this.openInicisPay(pyForm)
      // }

      // 공통코드 CD_00639(이니시스 테스트 허용 아이디) 조회 - 하위코드값: 회원아이디
      const inicisIdCdMap = await this.selCdMap(['CD_00639'])
      const inicisIdList = (inicisIdCdMap?.CD_00639 || []).map(item => item.cmmnCd?.toUpperCase())
      const currentMbEid = this.$store.getters['session/getMbEid']
      console.log('openPgPay::inicisIdList', inicisIdList, 'currentMbEid', currentMbEid)
      if (inicisIdList.includes(currentMbEid?.toUpperCase()) && ['10', '20', '21', '30', '31', '32', '33', '34', '35', '40'].includes(pyForm.pymtCd)) {
        console.log('>>> 이니시스 결제 시작')
        return await this.openInicisPay(pyForm)
      }

      let name
      switch (pyForm.pymtCd) {
        case '10': // 신용카드
          name = '카드'
          break
        case '20': // 가상계좌
          name = '가상계좌'
          break
        case '21': // 실시간계좌이체
          name = '계좌이체'
          break
        case '30': // 네이버페이
        case '31': // 카카오페이
        case '32': // 페이코
        case '33': // 삼성페이
        case '34': // 토스페이
        case '35': // 애플페이
          name = '간편'
          break
        case '40': // 문화상품권
          name = '문화상품권'
          break
        case '41': // 도서상품권
          name = '도서상품권'
          break
        case '38': // 공용 법인카드(무기명)
          name = '법인카드'
          break
      }

      return await this.rqstPgPay(name, '/or/ora/rqstPgPy', pyParam)
    },
    getPyRqstParam (pyForm, orNm) {
      console.log('getPyRqstParam::pyForm', pyForm)

      const param = {
        pySvcSeCd: '01', // 결제서비스구분코드(CD_00137) [01:일반결제, 02:빌링결제]
        ifSeCd: '01', // 연동구분코드(CD_00138) [01:인증요청, 02:결제승인요청, 03:전체취소요청, 04:부분취소요청]
        svcTyCd: this.getSvcTyCd(pyForm.spbkSeCd), // 서비스유형코드(CD_00139) [01:일반주문, 02:정기배송, 03:대량주문, 04:상품권주문]
        mbMngNo: pyForm.mbMngNo, // 회원관리번호
        mthd: pyForm.pymtCd, // 요청_결제수단 (CD_00050)
        pyAm: pyForm.pyAm, // 요청_결제금액
        pyNo: pyForm.pyNo, // 요청_주문ID(orderId)
        orNm, // 요청_주문명
        succUrl: pyForm?.succUrl || (process.env.WEB_BASE_URL + '/or/ora/SCR_ORA_0006'), // 요청_성공URL
        failUrl: pyForm?.failUrl || (process.env.WEB_BASE_URL + '/or/ora/SCR_ORA_0006'), // 요청_실패URL
        windowTgt: 'iframe', // 요청_목표창
        custNm: pyForm.ordNm, // 요청_고객이름
        custEml: pyForm.ordEml, // 요청_고객이메일
        taxfAm: this.toNumber(pyForm?.taxfAm) // 요청_면세금액
      }
      // 2024-03-29 주문명 + 주문번호
      if (!param.orNm) {
        // 2024-04-04 전시상품명 + 주문번호 100자리 안넘게 체크
        if (pyForm.orPdList[0].exhPdNm.length > 80) {
          pyForm.orPdList[0].exhPdNm = pyForm.orPdList[0].exhPdNm.substring(0, 80)
        }
        const prdCnt = pyForm.orPdList.length
        param.orNm = (prdCnt === 1) ? pyForm.orPdList[0].exhPdNm + '_' + pyForm.orNo : pyForm.orPdList[0].exhPdNm + ' 외 ' + (prdCnt - 1) + '건' + '_' + pyForm.orNo // 요청_주문명
      }

      switch (pyForm.pymtCd) {
        case '10': // 신용카드
        case '30': // 네이버페이
        case '31': // 카카오페이
        case '32': // 페이코
        case '33': // 삼성페이
        case '34': // 토스페이
        case '35': // 애플페이
          param.taxtExclAm = 0 // 요청_과세제외금액
          param.flMode = 'DIRECT' // 요청_결제창유형
          param.cardCoCd = pyForm?.cardCoCd // 요청_카드사코드
          param.esPyCd = this.getEsPyCd(pyForm.pymtCd) // 요청_간편결제사코드 (NAVERPAY, KAKAOPAY, PAYCO, SAMSUNGPAY, TOSSPAY, APPLEPAY)
          param.isUseIntrnCard = 'false' // 요청_해외카드결제여부
          param.cardIstmPlan = '0' // 요청_카드할부설정
          param.maxCardIstmPlan = '0' // 요청_최대카드할부설정
          param.useCardPnt = 'false' // 요청_카드사포인트사용여부
          param.useAppCardPyWindow = 'false' // 요청_앱카드결제창
          param.dctCd = '' // 요청_카드사의할인코드
          if (this.getMdiaSeCd() === '30') { // 요청_모바일ISP앱상점앱
            param.appScheme = 'daiso://'
          }
          break
        case '20': // 가상계좌
          param.taxtExclAm = 0 // 요청_과세제외금액
          param.isCultureExpense = 'false' // 요청_문화비지출여부
          param.vldtTm = this.getVrtAcunVldtTm(pyForm.spbkSeCd) // 요청_가상계좌유효시간
          param.dueDtm = '' // 요청_입금기한
          param.custMpNo = pyForm.ordCrryTno // 요청_고객휴대폰번호
          param.isExprCustMpNo = 'true' // 요청_휴대폰입력창노출여부
          param.cashRctwTyp = '지출증빙' // 요청_현금영수증발급용도
          param.isUseEscrow = 'false' // 요청_에스크로사용여부
          param.rfmtBankCd = pyForm.rfmtBankCd // 요청_고객환불계좌은행코드
          param.rfmtAcunNo = pyForm.rfmtAcunNo // 요청_고객환불계좌계좌번호
          param.rfmtDpsr = pyForm.rfmtAcunDpsrNm // 요청_고객환불계좌예금주
          break
        case '21': // 실시간계좌이체
          param.taxtExclAm = 0 // 요청_과세제외금액
          param.isCultureExpense = 'false' // 요청_문화비지출여부
          param.vldtTm = 24 // 요청_가상계좌유효시간
          param.cashRctwTyp = '지출증빙' // 요청_현금영수증발급용도
          param.isUseEscrow = 'false' // 요청_에스크로사용여부
          break
        case '38': // 공용 법인카드(무기명)
          param.cardNumber = pyForm.cardNumber1 + pyForm.cardNumber2 + pyForm.cardNumber3 + pyForm.cardNumber4 // 요청_카드번호
          param.cardPassword = pyForm.cardPassword // 요청_카드비밀번호
          param.cardExpirationMonth = pyForm.cardExpirationMonth // 요청_카드유효기간월
          param.cardExpirationYear = pyForm.cardExpirationYear // 요청_카드유효기간년도
          param.cardBzmnNo = pyForm.cardBzmnNo1 + pyForm.cardBzmnNo2 + pyForm.cardBzmnNo3 + pyForm.cardBzmnNo4 // 요청_사업자번호
          break
      }

      return param
    },
    getSvcTyCd (spbkSeCd) { // 서비스유형코드(CD_00139) [01:일반주문, 02:정기배송, 03:대량주문, 04:상품권주문]
      switch (spbkSeCd) {
        case '01': // 택배배송
        case '02': // 매장픽업
        case '05': // 오늘배송
          return '01' // 일반주문
        case '03': // 정기배송
          return '02'
        case '04': // 대량주문
          return '03'
      }
    },
    getVrtAcunVldtTm (spbkSeCd) { // 가상계좌유효시간 조회
      switch (spbkSeCd) {
        case '01': // 택배배송
          return 24 // 24시간
        case '02': // 매장픽업
          return 1 // 1시간
        case '04': // 대량주문
          return 24 // 24시간
        case '05': // 오늘배송
          return 1 // 1시간
      }
    },
    getEsPyCd (pymtCd) { // 간편결제사코드 조회
      switch (pymtCd) {
        case '30': return 'NAVERPAY'
        case '31': return 'KAKAOPAY'
        case '32': return 'PAYCO'
        case '33': return 'SAMSUNGPAY'
        case '34': return 'TOSSPAY'
        case '35': return 'APPLEPAY'
        default: return ''
      }
    },
    async rqstPgPay (name, url, pyParam) { // PG 결제요청 - clientKey 조회
      const result = await this.post(url, pyParam, name + ' 결제요청', 'rqstPgPay')
      if (result?.clientKey) {
        console.log('clientKey=', result.clientKey)
        return this.popupPgPay(result.clientKey, pyParam)
      }
    },
    async popupPgPay (clientKey, pyParam) { // PG 결제창 팝업
      const pgParam = { // 결제 수단 파라미터
        amount: pyParam.pyAm, // 결제금액(필수)
        taxFreeAmount: pyParam.taxfAm, // 면세금액
        orderId: pyParam.pyNo, // 주문ID(필수)
        orderName: pyParam.orNm, // 주문명(필수)
        customerName: pyParam.custNm, // 고객명
        successUrl: pyParam.succUrl, // 결제성공 리다이렉트URL(필수)
        failUrl: pyParam.failUrl, // 결제실패 리다이렉트URL(필수)
        windowTarget: pyParam.windowTarget ? pyParam.windowTarget : 'iframe'
      }

      if (this.getMdiaSeCd() === '30') {
        pgParam.appScheme = 'daiso://'
      }

      let mtdNm
      switch (pyParam.mthd) {
        case '10': // 신용카드
          mtdNm = '카드'
          if (pyParam?.cardCoCd) {
            pgParam.flowMode = 'DIRECT' // 결제창유형 [DEFAULT:카드/간편결제 기본결제창 호출, DIRECT:앱카드/간편결제사 결제창호출(앱카드는 cardCompany, 간편결제사 결제창은 easyPay 설정)]
            pgParam.cardCompany = pyParam.cardCoCd // 요청_카드사코드
          }
          break
        case '20': // 가상계좌
          mtdNm = '가상계좌'
          pgParam.validHours = pyParam.vldtTm
          break
        case '21': // 실시간계좌이체
          mtdNm = '계좌이체'
          pgParam.validHours = pyParam.vldtTm
          break
        case '30': // 네이버페이
        case '31': // 카카오페이
        case '32': // 페이코
        case '33': // 삼성페이
        case '34': // 토스페이
        case '35': // 애플페이
          mtdNm = '카드'
          pgParam.flowMode = pyParam.flMode // 결제창유형 [DEFAULT:카드/간편결제 기본결제창 호출, DIRECT:앱카드/간편결제사 결제창호출(앱카드는 cardCompany, 간편결제사 결제창은 easyPay 설정)]
          pgParam.easyPay = pyParam.esPyCd // 간편결제사코드 (NAVERPAY, KAKAOPAY, PAYCO, SAMSUNGPAY, TOSSPAY, APPLEPAY)
          break
        case '40': // 문화상품권
          mtdNm = 'CULTURE_GIFT_CERTIFICATE'
          break
        case '41': // 도서상품권
          mtdNm = 'BOOK_GIFT_CERTIFICATE'
          break
      }

      console.log('popupPgPay::mtdNm=' + mtdNm + ', pgParam=', JSON.stringify(pgParam))
      const tossPayments = await loadTossPayments(clientKey)
      return tossPayments.requestPayment(mtdNm, pgParam).catch((error) => {
        console.log('<<< 결제취소::error', error)
        return error
      })
    },
    async rqstPyPrcs (param) { // 결제처리요청
      return await this.post('/or/ora/rqstPyPrcs', param, '결제처리요청', 'rqstPyPrcs', true)
    },
    goOrOkPage (params) { // 결제성공 주문완료 페이지로 이동
      params.pyRslt = 'OK'
      this.$router.push({ name: 'or-ora-SCR_ORA_0006', params })
    },
    goOrFailPage (params) { // 결제실패 주문실패 페이지로 이동
      if (!params?.message) {
        params.message = '결제처리요청에 실패하였습니다.'
      }
      params.pyRslt = 'FAIL'
      this.$router.push({ name: 'or-ora-SCR_ORA_0006', params })
      // this.$router.push({ name: 'or-ora-SCR_ORA_0008', params })
    },
    async selStrInfo (strCd) { // 배송픽업매장 조회
      const param = { strCd }
      await this.$AxiosBuilder
        .params(param)
        .build()
        .get('/dl/dla-api/selStrInfo')
        .then((response) => {
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async selPickUpTime (strCd, param) { // 배송픽업매장 조회
      return await this.get('/dl/dla-api/selPickUpTime/' + strCd, param, '배송픽업매장 조회', 'selStrInfo')
    },
    async selPosiStrInfo (zip, isEmit = true) { // 거점매장 조회
      const posiStr = await this.get('/dl/dla-api/selPosiStrInfo', { zip }, '거점매장 조회', 'selPosiStrInfo')
      if (isEmit) {
        this.$EventBus.$emit('eb-able-dlv', !!posiStr?.strCd) // 배송가능여부 이벤트 발생 (거점매장 존재시만 배송가능)
      }
      return posiStr
    },
    async selStrBaseInfo (strInfo) { // 픽업매장 정보조회
      const param = { strCd: strInfo.strCd, mbMngNo: strInfo.mbMngNo }
      this.strInfo = await this.post('/or/bpa/selStrBaseInfo', param, '픽업매장 정보조회', 'selStrBaseInfo')
    },
    async selectPosiQuickStrInfo (zip, isEmit = true) { // 오늘배송매장 정보조회
      const posiStr = await this.get('/dl/dla-api/selPosiQuickStrInfo', { zip }, '오늘배송매장 정보조회', 'selPosiQuickStrInfo')
      if (isEmit) {
        this.$EventBus.$emit('eb-able-dlv', !!posiStr?.strCd && posiStr?.bsnSspYn !== 'Y') // 배송가능여부 이벤트 발생 (거점매장 존재 && 영업중단 아님)
      }
      return posiStr
    },
    async selDlvDtInfo (orNo) { // 주문완료 배송예정일 정보조회
      this.dlvDtInfo = await this.post('/or/ora/selDlvDtInfo', { orNo }, '배송예정일 정보조회', 'selDlvDtInfo')
    },
    async selMinFdrmAm () { // 정기배송가능 최소금액 조회
      const param = { orTyCd: '02', dlvFomCd: '01' }
      let minFdrmAm = 0
      await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/fb/fba/selDlvcPlcy')
        .then((response) => {
          const res = response.data
          // console.log('<정기배송가능최소금액<<', res?.data)
          minFdrmAm = res?.data.dlvcPlcyList[0].stdrAm
        })
        .catch((err) => {
          console.log(err)
        })
      // minFdrmAm = 20000
      return minFdrmAm
    },
    async selFdrmDlvcAm () { // 정기배송가능 기본배송비 조회
      const param = { orTyCd: '02', dlvFomCd: '01' }
      await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/fb/fba/selDlvcPlcy')
        .then((response) => {
          const res = response.data
          // console.log('<정기배송기본배송비<<', res?.data)
          this.fdrmDlvcInfo = res?.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async selMassDlvcAm () { // 대량주문가능 기본배송비 조회
      const param = { orTyCd: '03', dlvFomCd: '03' }
      await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/fb/fba/selDlvcPlcy')
        .then((response) => {
          const res = response.data
          // console.log('<대량주문기본배송비<<', res?.data)
          this.fdrmDlvcInfo = res?.data.dlvcPlcyList[0]
        })
        .catch((err) => {
          console.log(err)
        })
    },
    callBaroBillEdocByProductList (pdList) { // FO 전용 - 견적서 호출 (orNo X)
      this.$AxiosBuilder.data(pdList).build()
        .post('/or/bpa/orderInvoice')
        .then((response) => {
          console.log(response)
          if (response.data.message < 0) {
            this.$router.push('/mb/mbb/SCR_MBB_0097A')
          }
          const url = response.data.message
          if (url === 'NOMAIL') {
            this.$alert('견적서 발급 시 이메일 정보가 등록되어 있어야 합니다.', { center: true, dangerouslyUseHTMLString: true })
          } else {
            this.openPopup(url, '_blank', 'width = 1000px, height = 1024px')
          }
        })
    },
    saveAnCallBaroBillEdocFo (form) { // FO 전용 - 견적서 호출 (orNo O)
      return this.$AxiosBuilder.data(form).build()
        .post('/or/bpa/orSaveInvoice')
        .then((response) => {
          console.log(response)
          if (response.data.message < 0) {
            this.$router.push('/mb/mbb/SCR_MBB_0097A')
          }
          const url = response.data.message
          if (url === 'NOMAIL') {
            this.$alert('견적서 발급 시 이메일 정보가 등록되어 있어야 합니다.', { center: true, dangerouslyUseHTMLString: true })
          } else {
            this.openPopup(url, '_blank', 'width = 1000px, height = 1024px')
          }
        })
    },
    openPopup (url, type, option) {
      url = url.replaceAll('&amp;', '&')
      window.open(url, type, option)
    },
    // 현재 등록된 꾸러미 건수 카운트 ( 해지건 제외, 일시정지/중지 케이스 포함 )
    async chkFcrmPackCnt () {
      const param = { mbMngNo: this.getMbMngNo() }
      let fdrmCnt = 0
      await this.$AxiosBuilder
        .data(param)
        .build()
        .post('/fb/fba/selFdrmCount')
        .then((res) => {
          // console.log('꾸러미 기등록건수 : ' + res.data.data.existCnt)
          fdrmCnt = res.data.data.existCnt
        }).catch((err) => {
          console.log(err)
        })
      return fdrmCnt
    },
    // 토스트 팝업
    openToast (msg) {
      this.$notify({
        message: msg,
        position: 'center',
        showClose: false,
        duration: 3000,
        dangerouslyUseHTMLString: true,
      })
    },
    // 도서산간여부 리턴
    async chkIsmtDlvYn (testDlvFomCd, testOrTyCd, addrZip) {
      const dlvcPlcyRqstList = [{ dlvFomCd: testDlvFomCd, orTyCd: testOrTyCd, zip: addrZip }]
      const result = await this.post('/dl/dlp-api/selDlvcPlcyInfo', { dlvcPlcyRqstList }, '기본배송비정책 조회', 'selBassDlvcPlcy')

      if (result?.dlvcPlcyList?.length > 0 && (this.toNumber(result?.dlvcPlcyList[0].ismtDlvAm) + this.toNumber(result?.dlvcPlcyList[0].jejuAditDlvAm) > 0)) {
        // console.log(' 도서산간배송비 >>1>> ', this.toNumber(result?.dlvcPlcyList[0].ismtDlvAm) + this.toNumber(result?.dlvcPlcyList[0].jejuAditDlvAm))
        return true
      } else {
        // console.log(' 도서산간배송비 >>2>> ', this.toNumber(result?.dlvcPlcyList[0].ismtDlvAm) + this.toNumber(result?.dlvcPlcyList[0].jejuAditDlvAm))
        return false
      }
    },
    async selSkipCntrStckList () {
      this.isSkipOfflCntrStck = false
      const skipCntrStckList = await this.post('/or/orc/selSkipCntrStckList', null, '대량주문 재고체크 제외 상품 조회', 'selSkipCntrStckList')
      skipCntrStckList?.forEach((row) => {
        this.skipOfflCntrStckPdList.push(row)
        this.isSkipOfflCntrStck = true
      })
      console.log('this.skipOfflCntrStckPdList:', this.skipOfflCntrStckPdList)
    },
    async upChocPd (isChk, spbkNo, spbkSeCd) {
      const pdChocYn = isChk ? 'Y' : 'N'
      return await this.post('/or/orc/upPdChoc', { pdChocYn, spbkNo, spbkSeCd }, '장바구니 상품 선택상태 변경', 'upChkPd')
    },
    async upAllChocPd (isChk, spbkSeCd) {
      const pdChocYn = isChk ? 'Y' : 'N'
      return await this.post('/or/orc/upAllPdChoc', { pdChocYn, spbkSeCd }, '장바구니 전체상품 선택상태 변경', 'upChkPd')
    },
    // 크리테오 데이터 세팅 및 호출
    pushCriteo (item) {
      const tagItem = []
      const pdItem = []

      if (item.spbkList?.length > 0) {
        item.spbkList.forEach((value) => {
          pdItem.push({
            id: value.pdNo ?? '',
            price: value.sleUtpc * value.spbkQy ?? '',
            quantity: value.spbkQy ?? ''
          })
        })
      }

      tagItem.email = ''
      tagItem.zipCode = ''
      tagItem.cartItem = pdItem

      cartTag(tagItem)
    },
    formatWeight (weight) {
      if (isNaN(weight)) {
        return
      }
      return (weight / 1000).toFixed(1)
    },
    getAirbridgeSpbkNm (spbkSeCd) {
      switch (spbkSeCd) {
        case '01': // 택배배송 장바구니
          return 'std_delv'
        case '02': // 매장픽업 장바구니
          return 'store_pickup'
        case '04':// 대량배송 장바구니
          return 'bulk_delv'
        case '05':// 오늘배송 장바구니
          return 'today_delv'
      }
      return null
    },
    callAirBridgeForOrderInitiateCheckout (spbkSeCd, orPdList) {
      orPdList?.forEach((prd) => {
        const productListInfo = new this.$airbridge.OrderObject(this.getAirbridgeSpbkNm(spbkSeCd), parseInt(prd.sleUtpc * prd.spbkQy), '', prd.pdNo, prd.exhPdNm, prd.sleUtpc, 'KRW', prd.spbkQy, 1, prd.onlLclNm, prd.brndNm, '', prd.onlSclCd, prd.onlLclNm)
        this.$airbridge.orderInitiateCheckout(productListInfo)
      })
    },
    /**
     * 장바구니 로컬 스토리지 만료정보 조회
     * @param {*} key mbMngNo
     * @returns
     *  만료일 > 오늘 현재 : true
     *  그외 : false
     */
    getSpbkRcmPopLocalStorage (popNm, key) {
      const getStorage = localStorage.getItem(popNm)
      const today = dayjs().format('YYYYMMDD')
      if (getStorage && JSON.parse(getStorage)[key]) {
        const storage = JSON.parse(getStorage)
        const expireTime = JSON.parse(getStorage)[key]
        // 만료일 도달한 팝업 쿠키 삭제
        if (expireTime && (expireTime <= today || today.length < expireTime.toString().length)) {
          delete storage[key]
          localStorage.setItem(popNm, JSON.stringify(storage))
          return false
        }
        return (expireTime && expireTime > today) || false
      } else {
        return false
      }
    },
    async openInicisPay (pyForm) { // 이니시스 결제창 오픈
      console.log('>>> openInicisPay 호출', pyForm)

      // 콜백(SCR_ORA_0016)에서 뒤로가기 재진입시 주문서(이전 페이지)로 이동하기 위한 history 위치 기록
      // (이니시스 결제창 호출 직전 = 주문서 화면 기준의 history.length)
      pyForm.historyNo = window.history.length

      // 이니시스 콜백(SCR_ORA_0016)에서 복원하기 위해 매 호출마다 최신 pyForm 으로 덮어쓰기
      // (이전 결제시도/이전 주문의 pyForm 이 남아있으면 잘못된 금액·주문번호로 결제처리되는 사고 발생 → 반드시 갱신)
      localStorage.setItem('orCmptStore', JSON.stringify(pyForm))

      // 이니시스 설정 조회
      const configMidType = pyForm.svcTyCd === '04' ? 'GIFT_CERTIFICATE_PAYMENT' : 'GENERAL_PAYMENT'
      const configResponse = await this.$AxiosBuilder
        .build()
        .get(`/py/pyp/inicis/config?midType=${configMidType}`)

      if (!configResponse.data.success) {
        console.error('이니시스 설정 조회 실패')
        await this.$alert('결제 설정을 불러올 수 없습니다.')
        return
      }

      const inicisConfig = configResponse.data.data
      console.log('>>> 이니시스 설정:', inicisConfig)

      // 이니시스 SDK 로드
      await this.loadInicisSDK(inicisConfig.paymentJsUrl)

      // 주문명 생성
      // 1) 호출부에서 미리 orderName 을 넘긴 경우(예: 토스 백엔드가 내려준 주문명을 재사용하는 상품권 결제) 그대로 사용
      // 2) 그 외 일반 주문은 orPdList 기준으로 토스 형식("상품명 외 N건") 생성
      let orderName = pyForm.orderName
      if (!orderName) {
        if (!pyForm.orPdList || pyForm.orPdList.length === 0) {
          console.error('openInicisPay: orderName 또는 orPdList가 필요합니다.', pyForm)
          await this.$alert('결제 정보가 올바르지 않습니다.')
          return
        }
        const prdCnt = pyForm.orPdList.length
        orderName = pyForm.orPdList[0].exhPdNm
        if (prdCnt > 1) {
          orderName = orderName + ' 외 ' + (prdCnt - 1) + '건'
        }
      }
      // 주문번호 추가 (이니시스 관리자 거래조회용, 토스 형식: _구분자)
      const orNoSuffix = pyForm.orNo ? '_' + pyForm.orNo : ''
      if ((orderName + orNoSuffix).length <= 80) {
        orderName = orderName + orNoSuffix
      } else {
        // 80자 초과 시 상품명 잘라서 주문번호 붙이기
        const maxNameLen = 80 - orNoSuffix.length
        orderName = orderName.substring(0, maxNameLen) + orNoSuffix
      }

      try {
        // 백엔드에서 인증요청 데이터 생성
        // buyerName: 호출부에서 ordNm 또는 customerName 으로 전달 가능 (상품권 결제는 ordNm 미존재)
        const buyerName = pyForm.ordNm || pyForm.customerName || ''
        // 가상계좌 입금기한 유효시간 (시간 단위) - VBANK 결제 시에만 의미. 토스의 validHours와 동일 규칙.
        const vldtTm = (pyForm.pymtCd === '20') ? this.getVrtAcunVldtTm(pyForm.spbkSeCd) : null
        const midType = pyForm.svcTyCd === '04' ? 'GIFT_CERTIFICATE_PAYMENT' : 'GENERAL_PAYMENT'
        const response = await this.$AxiosBuilder
          .data({
            orderId: pyForm.pyNo,
            amount: String(pyForm.pyAm),
            goodsName: orderName,
            buyerName,
            vldtTm,
            midType
          })
          .build()
          .post('/py/pyp/inicis/auth')

        if (response.data.success) {
          const authData = response.data.data
          console.log('>>> 이니시스 인증요청 데이터:', authData)

          // pymtCd → 이니시스 P_PAY_TYPE 매핑 (대문자: CARD, VBANK, BANK, GIFTCARD)
          let payType = ''
          let onlyCardCode = '' // 간편결제 only_cardcode
          switch (pyForm.pymtCd) {
            case '10':
              payType = 'CARD'
              break
            case '20':
              payType = 'VBANK'
              break
            case '21':
              payType = 'BANK'
              break
            case '30': // 네이버페이
              payType = 'CARD'
              onlyCardCode = 'N'
              break
            case '31': // 카카오페이
              payType = 'CARD'
              onlyCardCode = 'O'
              break
            case '32': // 페이코
              payType = 'CARD'
              onlyCardCode = 'C'
              break
            case '33': // 삼성페이
              payType = 'CARD'
              onlyCardCode = 'B'
              break
            case '34': // 토스페이
              payType = 'CARD'
              onlyCardCode = 'H'
              break
            case '35': // 애플페이
              payType = 'CARD'
              onlyCardCode = 'A'
              break
            case '36': // 신한쏠페이
              payType = 'CARD'
              onlyCardCode = '14'
              break
            case '40':
              payType = 'GIFTCARD'
              break
          }

          // P_RESERVED: JSON String 형식 (매뉴얼 기준)
          let reservedObj = null
          if (payType === 'VBANK') {
            // 가상계좌 입금기한 - 백엔드(서버시간 기준)에서 계산되어 내려온 값 사용
            // (vbankDt: YYYYMMDD, vbankTm: HHmm) - vldtTm 미지정 시 백엔드에서 24h 폴백 처리됨
            reservedObj = { vbank_receipt: 'N', vbank_dt: authData.vbankDt, vbank_tm: authData.vbankTm }
          } else if (payType === 'BANK') {
            reservedObj = { bank_receipt: 'N' }
          } else if (onlyCardCode) {
            // 간편결제 - only_cardcode로 결제사 지정
            reservedObj = { only_cardcode: onlyCardCode }
          }
          const pReserved = reservedObj ? JSON.stringify(reservedObj) : null

          // 이니시스 결제창 호출
          const obj = {
            P_MID: authData.mid,
            P_OID: authData.oid,
            P_PAY_TYPE: payType,
            P_DEVICE_TYPE: 'WEB', // PC: WEB, 모바일: MOBILE (매뉴얼 기준)
            P_IDCCODE: authData.idcCode,
            P_AMT: authData.amt,
            P_GOODS: authData.goods,
            P_UNAME: authData.uname,
            P_NEXT_URL: inicisConfig.callbackUrl || (process.env.WEB_BASE_URL + '/or/ora/SCR_ORA_0016'), // 이니시스 인증결과 수신 URL
            P_NOTI_URL: authData.notiUrl || (process.env.API_BASE_URL + '/or/pyr/inicis/vrtAcunNoti'),
            P_NOTI: authData.noti || '',
            P_TIMESTAMP: authData.timestamp,
            P_CHKFAKE: authData.chkfake,
            P_CHARSET: authData.charset || 'UTF-8'
          }
          // P_RESERVED는 값이 있을 때만 세팅 (빈값 전송 시 이니시스 오류 발생)
          if (pReserved) {
            obj.P_RESERVED = pReserved
          }

          console.log('>>> 이니시스 결제창 호출 파라미터:', obj)

          if (typeof window.INIPayPro !== 'undefined') {
            window.INIPayPro.requestPayment(obj)
          } else {
            console.error('이니시스 SDK가 로드되지 않았습니다.')
            await this.$alert('결제 모듈을 로드할 수 없습니다.')
          }
        } else {
          console.error('인증요청 실패:', response.data)
          await this.$alert('결제 요청에 실패했습니다.')
        }
      } catch (error) {
        console.error('이니시스 결제 오류:', error)
        await this.$alert('결제 처리 중 오류가 발생했습니다.')
      }
    },
    loadInicisSDK (sdkUrl) { // 이니시스 SDK 로드
      const loadScript = (id, src, charset) => {
        return new Promise((resolve, reject) => {
          if (document.getElementById(id)) {
            resolve()
            return
          }
          const script = document.createElement('script')
          script.id = id
          script.src = src
          if (charset) { script.charset = charset }
          script.onload = resolve
          script.onerror = () => reject(new Error(src + ' 로드 실패'))
          document.head.appendChild(script)
        })
      }

      return new Promise((resolve, reject) => {
        if (typeof window.INIPayPro !== 'undefined') {
          resolve()
          return
        }

        const jqueryPromise = (typeof window.jQuery !== 'undefined')
          ? Promise.resolve()
          : loadScript('inicis-jquery', 'https://code.jquery.com/jquery-3.7.1.min.js')

        jqueryPromise
          .then(() => {
            if (typeof window.$ === 'undefined') {
              window.$ = window.jQuery
            }
            return loadScript('inicis-sdk', sdkUrl || 'https://paypro.inicis.com/std/payment/js/INIPayPro.js', 'UTF-8')
          })
          .then(() => {
            console.log('>>> 이니시스 SDK 로드 완료')
            resolve()
          })
          .catch((err) => {
            console.error('>>> 이니시스 SDK 로드 실패', err)
            reject(err)
          })
      })
    }
  }
}

export default orMixin
